<template>
  <div class="page_order_care">
    <!-- 提示 -->
    <!-- 通知环节 -->

    <div class="top_content">
      <top-title :name="asideName" :desc="statusMessage(asideActive)" classType="1"></top-title>
      <template v-if="asideActive!=26 && asideActive!=27 && asideActive!=28 && asideActive!=29 && asideActive!=30 && asideActive!=31 && asideActive!=32 && asideActive!=33 && asideActive!=34">
        <icon-box v-if="!venderType" :openInfo="openInfo" :asideName="asideName"></icon-box>
        <icon-boxs v-else :openInfo="openInfo" :asideName="asideName"></icon-boxs>
      </template>
    </div>

    <!-- 数据展示 -->
    <div class="main_content" style="min-width: 1046px">
      <div class="tab_all">
        <span class="tab_item" :class="{ active: selectIndex == 1 }" @click="selectIndex = 1" style="margin-left: 28px">{{
          asideName == "好评感谢（自营）" ? "好评感谢" : asideName == "中差评安抚（自营）" ? "中差评安抚" : asideName
        }}</span>
        <span class="tab_item" :class="{ active: selectIndex == 2 }" @click="selectIndex = 2">短信记录</span>
        <span class="tab_item" :class="{ active: selectIndex == 3 }" @click="(selectIndex = 3), analysisEffect()"
          v-if="asideActive == 2 || asideActive == 3 || asideActive == 4 || asideActive == 13 || asideActive == 31">{{ payOrEvaluation
          }}</span>
        <span class="tab_item" :class="{ active: selectIndex == 4 }" @click="(selectIndex = 4),queryDdRecordList()"
          v-if="hasDongDong">咚咚消息记录</span>
      </div>

      <!-- 第一个模块 tab1 -->
      <div v-if="selectIndex == 1">
        <!-- 提示 -->
        <!-- <div style="margin:20px 30px;color:red">
          温馨提示：双11活动期间官方模板短信发送会限额，建议商家在使用催付、催评等订单关怀功能时尽量指定高价值商品进行自动提醒，尽可能规避超额无法发送的问题。
        </div> -->
        <!-- 按钮 -->
        <div>
          <span class="create_btn3" @click="newBtn()">
            <img src="@/assets/images/member/new_establish.png" style="
                          display: inline-block;
                          float: left;
                          width: 14px;
                          height: 14px;
                          color: #ffffff;
                          margin: 8px -2px 0px 12px;
                        " />
            创建任务
          </span>
          <div class="right_allBtn">
            开启状态：
            <el-select v-model="search1.isOpen" placeholder="请选择" style="width: 116px">
              <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-input v-model="search1.searchKeyWord" :placeholder="hasDongDong ?'请输入任务名称、短信内容、咚咚消息内容' : '请输入任务名称、短信内容'"
              style="width: 280px; margin: 0 16px 0 8px"></el-input>
            <el-button v-zoom="{ name: '任务列表查询', from: asideName }" label="开启状态" icon="el-icon-search" type="primary"
              class="status_btn status_btn1" @click="seacherResult" :disabled="tableLoading">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetBtn">重置</el-button>
          </div>
        </div>
        <!-- <div style="margin:20px 30px;color:red">
          温馨提示：618活动期间官方模板短信发送会限额，建议商家在使用催付、催评等订单关怀功能时尽量指定高价值商品进行自动提醒，尽可能规避超额无法发送的问题。
        </div> -->

        <!-- <el-alert
          :closable="false"
          style="width:1010px;margin:20px 30px;"
          title="温馨提示：618活动期间官方模板短信发送会限额，建议商家在使用催付、催评等订单关怀功能时尽量指定高价值商品进行自动提醒，尽可能规避超额无法发送的问题。"
          type="error">
       </el-alert> -->
        <!-- 表格 -->
        <div class="clear-float" style="padding: 0 28px">
          <el-table :data="tableList" style="width: 100%; margin-top: 22px" :header-cell-style="{ background: '#fafafa' }"
            v-loading="tableLoading">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="taskName" label="任务名称"> </el-table-column>
            <el-table-column prop="content" label="短信内容" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.content | enVToChinese }}
              </template>
            </el-table-column>
            <el-table-column v-if="hasDongDong" prop="content" label="咚咚消息内容" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.dongDongContent || '-' }}
              </template>
            </el-table-column>
            <!-- <el-table-column  v-if="apiTypeActive=='remind'" label="任务时间" width="80">
              <template slot-scope="scope">
                
              </template>
            </el-table-column> -->
            <el-table-column label="任务时间" width="80">
              <template slot-scope="scope">
                <span v-if="apiTypeActive == 'remind'">{{ scope.row.persistentOpenFlag | persistentOpenFlagStr }}</span>
                <span v-else>{{ scope.row.taskType | taskTypeStr }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
            <el-table-column prop="updateTime" label="最后修改时间" width="160"></el-table-column>
            <el-table-column prop="sort" label="优先级" width="165">
              <template slot="header" v-if="isMemCare">
                <div>
                  优先级
                  <el-tooltip class="item" effect="light"
                    content="数字越小优先级越高会优先发送，同一会员同时满足多个任务只发优先级高的，其他不发，避免重复，优先级相同则以最后修改时间先发。" placement="top-start">
                    <span class="question_icon">?</span>
                  </el-tooltip>
                </div>
              </template>
              <template slot="header" v-else>
                <div>
                  优先级
                  <el-tooltip class="item" effect="light"
                    content="数字越小优先级越高会优先发送，同一订单同时满足多个任务只发优先级高的，其他不发，避免重复，优先级相同则以最后修改时间先发。" placement="top-start">
                    <span class="question_icon">?</span>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.sort" @change="handleChange(scope.row)" :min="1" :max="1000000000"
                  size="mini"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column width="100" label="开启状态">
              <template slot-scope="scope">
                <el-switch v-zoom="{ name: '任务开启状态改变', from: asideName }" label="开启状态" v-model="scope.row.isOpen"
                  :active-value="1" :inactive-value="2" @change="changeSwitch(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <!-- <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
                <el-button type="text" @click="delteItem(scope.row)" :style="{'color':'#f56c6c'}">删除</el-button>-->
                <el-button @click="editOrderCare(scope.row)" type="text" v-zoom="{ name: '任务编辑', from: asideName }"
                  class="edit_btn">编辑</el-button>
                <el-button @click="deleteOrderCare(scope.row)" type="text" v-zoom="{ name: '任务删除', from: asideName }"
                  class="cloce_btn">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding: 20px 28px 30px; text-align: right; margin-bottom: 0px">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 50, 100, 500, 1000]" :total="paginationInfo.totalCount" :page-size="paginationInfo.pageSize"
            :current-page="paginationInfo.tableCurrentPage" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>

      <!-- 第二个模块 tab2 -->
      <div v-if="selectIndex == 2" class="tab_item_box">
        <!-- 查询 -->
        <div class>
          <div class="search_item">
            <p class="title">买家账号：</p>
            <el-input v-model="smsSearchParams.pin" placeholder="输入买家账号" size="small" style="width: 280px"></el-input>
          </div>

          <div class="search_item">
            <p class="title">订单编号：</p>
            <el-input v-model="smsSearchParams.orderId" placeholder="输入订单编号" size="small" style="width: 280px"></el-input>
          </div>

          <div class="search_item1">
            <p class="title">短信内容：</p>
            <el-input v-model="smsSearchParams.content" placeholder="输入短信内容" size="small" style="width: 280px"></el-input>
          </div>

          <div class="search_item">
            <p class="title">发送状态：</p>
            <el-select v-model="smsSearchParams.status" placeholder="请选择" size="small" style="width: 280px">
              <el-option v-for="item in stautsOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="search_item my_select_time">
            <div class="title">发送时间：</div>

            <el-date-picker prefix-icon="no_icon" v-model="smsSearchParams.sentTimeStart" type="datetime"
              placeholder="开始时间" size="small" :picker-options="pickerOptions0" value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker prefix-icon="no_icon" v-model="smsSearchParams.sentTimeEnd" :picker-options="pickerOptions1"
              type="datetime" placeholder="结束时间" size="small" value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px" class="time2" :clearable="false"></el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <div style="text-align: center">
            <el-button v-zoom="{ name: '短信记录列表查询', from: asideName }" label="开启状态" icon="el-icon-search" type="primary"
              style="margin: 0 auto" class="status_btn status_btn1" @click="getSmsSentRecordList1"
              :disabled="talbeLoading1">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetBtn1">重置</el-button>
          </div>
        </div>
        <div style="color: #fe4d45; margin-bottom: 10px">
          注意： 关怀类短信改官方发送后无手机号返回；
        </div>
        <!-- 表格部分 -->
        <div class="table-box" v-if="tableState" style="margin-top: 4px">
          <el-table v-loading="talbeLoading1" ref="multipleTable" :data="smsTableList" tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa' }" style="width: 100%">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column label="买家账号" prop="desensitizePin" :show-overflow-tooltip="!allShow">
              <!-- <template slot-scope="scope">
                {{ venderType ? "--" : scope.row.pin }}
              </template> -->
            </el-table-column>
            <!-- <el-table-column
              prop="mobile"
              label="手机号码"
              :show-overflow-tooltip="!allShow"
              width="100"
              v-if="asideActive !==4"
            >
               <template slot-scope="scope" 
              >   -->
            <!-- <div class="hoveTitle" v-if="!allShow">{{scope.row.content}}</div> -->
            <!-- <span class="box" v-if="!scope.row.mobileState">
                  <span
                    class="hover-show"
                    @click="showInfo( scope.row, scope.$index)"
                    style="width: 110px"
                    :style="{ background: changeColor }"
                  >
                        显示手机号码
                  </span>
                  <span>{{scope.row.mobile}}</span> 
                </span>
                
                <div v-else>{{scope.row.mobile}}</div>
              </template>
            </el-table-column> -->
            <!-- <el-table-column
              prop="star"
              label="评价星级"
              :show-overflow-tooltip="!allShow"
              width="100"
              v-if="asideActive ==6 || asideActive == 7"
            >
              <template slot-scope="scope">{{scope.row.star}}星</template>
            </el-table-column> -->
            <!-- <el-table-column prop="mobile" label="手机号">
              <template slot-scope="scope">
                {{ scope.row.mobile || "--" }}
              </template>
            </el-table-column> -->
            <el-table-column prop="orderId" label="订单编号" :show-overflow-tooltip="!allShow"></el-table-column>
            <el-table-column label="短信内容" min-width="300">
              <template slot="header" slot-scope="scope">
                <div style="
                              height: 40px;
                              line-height: 40px;
                              overflow: hidden;
                              float: left;
                            ">
                  短信内容
                </div>
                <div class="table-message" v-if="!allShow" style="color: #3840c7; margin-left: 56px; line-height: 40px"
                  @click="allShowBtn(1)">
                  展开全部
                </div>
                <div class="table-message" v-if="allShow" style="color: #3840c7; margin-left: 56px; line-height: 40px"
                  @click="allShowBtn(2)">
                  单行显示
                </div>
              </template>
              <template slot-scope="scope">
                <div class="hoveTitle" v-if="!allShow">
                  {{ scope.row.content }}
                </div>
                <div v-if="allShow">{{ scope.row.content }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="comfrom" label="提醒类型">
              <template slot-scope="scope">
                <span>{{ scope.row.comfrom }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="smsNumber" label="实际扣费(条)" width="110"></el-table-column>
            <el-table-column label="发送状态" width="110">
              <template slot-scope="scope">
                <span>{{ statusStr(scope.row.sendStatus) || statusStr(scope.row.status) }}</span>
                <!-- 要改成写死  已发送  -->
                <!-- <span>已发送</span> -->
              </template>
            </el-table-column>
            <el-table-column prop="sendTime" label="发送时间" :show-overflow-tooltip="!allShow"></el-table-column>
          </el-table>

          <div style="
                        padding: 20px 28px 30px;
                        text-align: right;
                        margin-bottom: 0px;
                      ">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 50, 100, 500, 1000]" :total="smsTableTotalCount" :page-size="smsSearchParams.size"
              :current-page="smsSearchParams.current" @size-change="handleSizeChangeSms"
              @current-change="handleCurrentChangeSms"></el-pagination>
          </div>
          <!-- <pagination @transferName="smsPaginationFunction" :total="smsTableTotalCount"></pagination> -->
        </div>
      </div>

      <!-- 第三个模块 tab3 -->
      <div v-if="selectIndex == 3" class="tab_item_box">
        <div>
          <div class="search-box">
            <div class="search-box-item">
              <div class="data_title" v-if="activeOne"><span class="line"></span>
                <span style="color: #333">分析类型</span>
              </div>
              <div style="margin-bottom: 15px">
                <el-radio-group v-model="analysisType" @change="changeAnalysisType">
                  <el-radio :label="0">汇总效果</el-radio>
                  <el-radio :label="1">指定任务</el-radio>
                </el-radio-group>
                <el-select v-model="taskId" placeholder="请选择" @change="changeSingleTask" :disabled="analysisType==0" style="margin-left: 20px;">
                  <el-option
                    v-for="item in singleTasks"
                    :key="item.id"
                    :label="item.taskName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-box-item" v-if="asideActive == 2">
              <!-- 催付提醒添加消息类型 -->
              <div class="data_title"><span class="line"></span>
                <span style="color: #333">消息类型</span>
              </div>
              <div style="margin-bottom: 15px">
                <el-select v-model="smsType" placeholder="请选择" @change="changeSingleTask">
                  <el-option label="不限" value=""></el-option>
                  <el-option label="短信" value="0"></el-option>
                  <el-option label="咚咚消息" value="99"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <!-- 今日数据监控 -->
          <div class="data_title"><span class="line"></span><span style="color: #333">今日数据监控</span></div>
          <div>
            <div v-for="(item, index) in asideActive != 13 ?  asideActive == 31 ? todayData3 :todayData : todayData2" :key="index" class="today_item"
              :class="{ width25: asideActive == 5 }">
              <div class="data_name">
                {{ item.name }}
                <el-tooltip class="item" effect="light" :content="roiTip" placement="top-start" v-if="index == 4">
                  <span class="question_icon">?</span>
                </el-tooltip>
              </div>
              <div class="data_num">
                <span style="color: #fe4d45" v-if="item.name != '催评成功率'">{{ item.data }}</span>
                <span style="color: #fe4d45" v-else>{{ Number(item.data) * 100 }}%</span>
                <span class="data_num_unit">{{ item.unit }}</span>
              </div>
              <div class="edit_price" v-if="index == 4" @click="unitPriceView = true">
                修改单价
              </div>
            </div>
          </div>
          <!-- 往日数据监控分析 -->
          <div class="data_title"><span class="line"></span><span style="color: #333">往日数据监控分析</span></div>

          <div style="overflow: hidden; line-height: 32px; margin-top: 20px">
            <div style="float: left">
              <el-radio-group v-model="rangeCountParams.timeRange" @change="selectTimeRange">
                <el-radio label="threeDays" class="marginRight_50">近三天</el-radio>
                <el-radio label="sevenDays" class="marginRight_50">近七天</el-radio>
                <el-radio label="month" class="marginRight_50">近一个月</el-radio>
                <el-radio label="range">
                  <span>自定义</span>
                  <div class="my_select_time">
                    <el-date-picker prefix-icon="no_icon" v-model="rangeCountParams.startTime" type="date"
                      placeholder="选择日期时间" :disabled="timeRangeView" :picker-options="pickerOptions2" @change="isInMonth"
                      size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      style="width: 120px; margin-left: 8px; font-size: 12px" class="time1"
                      :clearable="false"></el-date-picker>
                    <div class="time_to_text" :class="{ to_text_disabled: timeRangeView }">
                      至
                    </div>
                    <el-date-picker prefix-icon="no_icon" v-model="rangeCountParams.endTime" type="date"
                      placeholder="选择日期时间" :disabled="timeRangeView" :picker-options="pickerOptions3" @change="isInMonth"
                      size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 135px; font-size: 12px"
                      class="time2" :clearable="false"></el-date-picker>
                    <i class="el-icon-circle-close date_icon1" @click="clearTime2"></i>
                    <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <el-button v-zoom="{ name: '催付效果数据查询', from: asideName }" icon="el-icon-search" class="status_btn status_btn3"
              @click="seacherResultCare" :disabled="talbeLoading3">查询</el-button>
            <el-button class="status_btn status_btn4" @click="resetBtn3">重置</el-button>
            <div @click="exportData" class="float_right_button" >
              <div v-zoom="{ name: '催付效果数据导出', from: asideName }">
                <el-button>导出数据</el-button>
              </div>
            </div>
          </div>
          <!-- 表格-往日数据 -->
          <div class="table-box" v-if="tableState && asideActive != 13 && asideActive != 31">
            <el-table v-loading="talbeLoading3" ref="multipleTable" :data="rangeCountList" tooltip-effect="light"
              :header-cell-style="{ background: '#fafafa', border: '0px' }" style="width: 100%">
              <template slot="empty">
                <div>
                  <img src="@/assets/images/default/暂无任何数据.png" />
                  <span style="margin-left: -140px">暂无任何数据</span>
                </div>
              </template>
              <el-table-column prop="sendTime" label="统计时间" v-if="asideActive != 5"></el-table-column>
              <el-table-column label="催付订单数" v-if="asideActive != 5">
                <!-- v-if="asideActive!==15" -->
                <template slot-scope="scope">
                  <span>{{ scope.row.recordCount }}单</span>
                </template>
              </el-table-column>
              <el-table-column label="挽回订单数" v-if="asideActive != 5">
                <template slot-scope="scope">
                  <span @click="returnOrderNum(scope.row, 1)" :style="{ color: changeColor, cursor: 'pointer' }">{{
                    scope.row.count }}单</span>
                </template>
              </el-table-column>
              <el-table-column label="挽回金额" v-if="asideActive != 5">
                <template slot-scope="scope">
                  <span>{{ scope.row.money }}元</span>
                </template>
              </el-table-column>
              <el-table-column label="催付成功率" v-if="asideActive != 5">
                <template slot-scope="scope">
                  <span>{{ scope.row.result | toPercentSign }}</span>
                </template>
              </el-table-column>
              <el-table-column label="ROI" v-if="asideActive != 13">
                <template slot="header">
                  <div class="roi">
                    <span style="margin-right: 4px">ROI</span>
                    <el-tooltip class="item" effect="light" :content="roiTip" placement="top-start">
                      <!-- <img src="../../assets/images/ask.png" alt style /> -->
                      <span class="question_icon" :style="{
                        color: changeColor,
                        border: '1px solid ' + changeColor,
                      }">?</span>
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div>{{ scope.row.roi }}</div>
                  <!-- <div v-if="asideActive==17">{{scope.row.roi}}</div>
                  <div v-else>{{scope.row.expeditROI}}</div>-->
                </template>
              </el-table-column>
              <!-- </div> -->

              <!-- <div v-if="asideActive==5"> -->
              <el-table-column prop="subTime" label="统计时间" v-if="asideActive == 5"></el-table-column>
              <el-table-column label="催评通知数" v-if="asideActive == 5">
                <template slot-scope="scope">
                  <span>{{ scope.row.recordCount }}单</span>
                </template>
              </el-table-column>
              <el-table-column label="催评订单数" v-if="asideActive == 5">
                <template slot-scope="scope">
                  <span @click="returnOrderNum(scope.row, 1)" :style="{ color: changeColor, cursor: 'pointer' }">{{
                    scope.row.evaluationResulCount }}单</span>
                </template>
              </el-table-column>
              <el-table-column label="催评成功数" v-if="asideActive == 5">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderPayment }}元</span>
                </template>
              </el-table-column>
              <el-table-column label="催评成功率" v-if="asideActive == 5">
                <template slot-scope="scope">
                  <span>{{ scope.row.evaluationResultRate }}</span>
                </template>
              </el-table-column>
              <!-- </div> -->

              <!-- 表格-均值 -->
              <div class="table-bottom" slot="append" style="width: 100%; border: 1px solid #eaeaea"
                v-if="JSON.stringify(calculateCuifuAvg) !== '{}'">
                <el-table ref="multipleTable" :header-cell-style="{
                  background: '#fafafa',
                  'font-weight': 'normal',
                }" style="width: 100%">
                  <el-table-column label="统计时间">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two" :style="{ color: changeColor }">
                        均值
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="催付订单数">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two">{{ calculateCuifuAvg.recordCount }}单</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="挽回订单数">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two" :style="{ color: changeColor }">{{ calculateCuifuAvg.count }}单</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="挽回金额">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two">{{ calculateCuifuAvg.money || "0.00" }}元</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="lv" label="催付成功率">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two">
                        {{ calculateCuifuAvg.result | toPercentSign }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROI" v-if="asideActive != 13">
                    <template slot="header">
                      <div class="special-two">{{ calculateCuifuAvg.roi }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 表格-汇总 -->
              <div class="table-bottom" slot="append" v-if="JSON.stringify(summaryDto) !== '{}'">
                <el-table ref="multipleTable" :header-cell-style="{
                  background: '#f6f6f6',
                  'font-weight': 'normal',
                }" style="width: 100%">
                  <el-table-column label="统计时间">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two" :style="{ color: changeColor }">
                        汇总
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="催付订单数">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two">{{ summaryDto.recordCount }}单</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="挽回订单数">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two" :style="{ color: changeColor }">{{ summaryDto.count }}单</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="挽回金额">
                    <template slot="header" slot-scope="scope">
                      <div class="special-two">{{ summaryDto.money }}元</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="lv" label="催付成功率">
                    <template slot="header">
                      <div class="special-two">{{ summaryDto.result | toPercentSign }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROI" v-if="asideActive != 13">
                    <template slot="header">
                      <div class="special-two">{{ summaryDto.roi }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-table>
          </div>
          <div class="table-box" v-else-if="asideActive == 31">
            <el-table v-loading="talbeLoading3" ref="multipleTable" :data="rangeCountList" tooltip-effect="light"
              :header-cell-style="{ background: '#fafafa', border: '0px' }" style="width: 100%">
              <el-table-column prop="sendTime" label="统计时间"></el-table-column>
              <el-table-column label="发送订单数">
                <template slot-scope="scope">
                  <span>{{ scope.row.sendOrderCount }}条</span>
                </template>
              </el-table-column>
              <el-table-column label="凑单付款订单数">
                <template slot-scope="scope">
                  <span>{{ scope.row.mergeOrderPayCount }}单</span>
                </template>
              </el-table-column>
              <el-table-column label="凑单成交金额">
                <template slot-scope="scope">
                  <span>{{scope.row.mergeOrderMoney }}元</span>
                </template>
              </el-table-column>
              <el-table-column label="凑单成功率">
                <template slot-scope="scope">
                  <span>{{ scope.row.successRate }}%</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 表格-汇总 -->
            <div class="table-bottom" slot="append" v-if="JSON.stringify(summaryDto) !== '{}'">
              <el-table ref="multipleTable" :header-cell-style="{
                background: '#f6f6f6',
                'font-weight': 'normal',
              }" style="width: 100%">
                <el-table-column label="统计时间">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two" :style="{ color: changeColor }">
                      汇总
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="发送订单数">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two">{{ summaryDto.sendOrderCount }}单</div>
                  </template>
                </el-table-column>
                <el-table-column label="凑单付款订单数">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two" :style="{ color: changeColor }">{{ summaryDto.mergeOrderPayCount }}单</div>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="凑单成交金额">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two">{{ summaryDto.mergeOrderMoney }}元</div>
                  </template>
                </el-table-column>
                <el-table-column prop="lv" label="凑单成功率">
                  <template slot="header">
                    <div class="special-two">
                      {{ summaryDto.successRate }}%
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="table-box" v-else>
            <el-table v-loading="talbeLoading3" ref="multipleTable" :data="rangeCountList" tooltip-effect="light"
              :header-cell-style="{ background: '#fafafa', border: '0px' }" style="width: 100%">
              <el-table-column prop="makeEvaluationTime" label="时间"></el-table-column>
              <el-table-column label="催评通知数">
                <!-- v-if="asideActive!==15" -->
                <template slot-scope="scope">
                  <span>{{ scope.row.count }}条</span>
                </template>
              </el-table-column>
              <el-table-column label="催评订单数">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderCnt }}单</span>
                </template>
              </el-table-column>
              <el-table-column label="催评成功数">
                <template slot-scope="scope">
                  <span @click="returnOrderNum(scope.row, 1)" :style="{ color: changeColor, cursor: 'pointer' }">{{
                    scope.row.orderSuccessCnt }}单</span>
                </template>
              </el-table-column>
              <el-table-column label="催评成功率">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderSuccessRate | toPercentSign }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 表格-均值 -->
            <div class="table-bottom" slot="append" v-if="JSON.stringify(calculateCuifuAvg) !== '{}'">
              <el-table ref="multipleTable" :header-cell-style="{
                background: '#fafafa',
                'font-weight': 'normal',
              }" style="width: 100%">
                <el-table-column label="时间">
                  <template slot="header">
                    <div class="special-two" :style="{ color: changeColor }">
                      均值
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="催评通知数">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two">{{ calculateCuifuAvg.avgCount }}条</div>
                  </template>
                </el-table-column>
                <el-table-column label="催评订单数">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two" :style="{ color: changeColor }">{{ calculateCuifuAvg.avgOrderCnt }}单</div>
                  </template>
                </el-table-column>
                <el-table-column label="挽回金额">
                  <template slot="header">
                    <div class="special-two">{{ calculateCuifuAvg.avgOrderSuccessCnt }}单</div>
                  </template>
                </el-table-column>
                <el-table-column label="催评成功率">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two">
                      {{ calculateCuifuAvg.avgOrderSuccessRate | toPercentSign }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 表格-汇总 -->
            <div class="table-bottom" slot="append" v-if="JSON.stringify(summaryDto) !== '{}'">
              <el-table ref="multipleTable" :header-cell-style="{
                background: '#f6f6f6',
                'font-weight': 'normal',
              }" style="width: 100%">
                <el-table-column label="统计时间">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two" :style="{ color: changeColor }">
                      汇总
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="催付订单数">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two">{{ summaryDto.totalCount }}单</div>
                  </template>
                </el-table-column>
                <el-table-column label="挽回订单数">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two" :style="{ color: changeColor }">{{ summaryDto.totalOrderCnt }}单</div>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="挽回金额">
                  <template slot="header" slot-scope="scope">
                    <div class="special-two">{{ summaryDto.totalSuccessCnt }}单</div>
                  </template>
                </el-table-column>
                <el-table-column prop="lv" label="催付成功率">
                  <template slot="header">
                    <div class="special-two">
                      {{ summaryDto.totalSuccessRate | toPercentSign }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <!-- 第四个模块 -->
      <div v-if="selectIndex == 4" class="tab_item_box">
        <div style="margin-bottom: 10px;">
          <div class="search_item">
            <p class="title">买家账号：</p>
            <el-input v-model="ddSearchParams.pin" placeholder="输入买家账号" size="small" style="width: 280px"></el-input>
          </div>

          <div class="search_item">
            <p class="title">任务名称：</p>
            <el-input v-model="ddSearchParams.taskName" placeholder="输入任务名称" size="small" style="width: 280px"></el-input>
          </div>

          <div class="search_item1">
            <p class="title">消息内容：</p>
            <el-input v-model="ddSearchParams.content" placeholder="输入消息内容" size="small" style="width: 280px"></el-input>
          </div>

          <div class="search_item">
            <p class="title">发送状态：</p>
            <el-select v-model="ddSearchParams.status" placeholder="请选择" size="small" style="width: 280px">
              <el-option v-for="item in stautsOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
                <el-option label="发送失败" value="2"></el-option>
            </el-select>
          </div>

          <div class="search_item my_select_time">
            <div class="title">发送时间：</div>

            <el-date-picker prefix-icon="no_icon" v-model="ddSearchParams.sendTimeStart" type="datetime"
              placeholder="开始时间" size="small" :picker-options="pickerOptionsDD0" value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker prefix-icon="no_icon" v-model="ddSearchParams.sendTimeEnd" :picker-options="pickerOptionsDD1"
              type="datetime" placeholder="结束时间" size="small" value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px" class="time2" :clearable="false"></el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <div style="text-align: center">
            <el-button v-zoom="{ name: '咚咚消息记录列表查询', from: asideName }" label="开启状态" icon="el-icon-search" type="primary"
              style="margin: 0 auto" class="status_btn status_btn1" @click="queryDdRecordList"
              :disabled="ddLoading">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetBtndd">重置</el-button>
          </div>
        </div>
        <!-- 表格部分 -->
        <div class="table-box" style="margin-top: 4px">
          <el-table v-loading="ddLoading" ref="multipleTable" :data="ddTableList" tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa' }" style="width: 100%">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column label="买家账号" prop="pin">
            </el-table-column>

            <el-table-column prop="taskName" label="任务名称" ></el-table-column>
            <el-table-column label="咚咚消息内容" min-width="300">
              <template slot="header" slot-scope="scope">
                <div style="
                  height: 40px;
                  line-height: 40px;
                  overflow: hidden;
                  float: left;
                ">
                  咚咚消息内容
                </div>
                <div class="table-message" v-if="!allShow" style="color: #3840c7; margin-left: 56px; line-height: 40px"
                  @click="allShowBtn(1)">
                  展开全部
                </div>
                <div class="table-message" v-if="allShow" style="color: #3840c7; margin-left: 56px; line-height: 40px"
                  @click="allShowBtn(2)">
                  单行显示
                </div>
              </template>
              <template slot-scope="scope">
                <div class="hoveTitle" v-if="!allShow">
                  {{ scope.row.content }}
                </div>
                <div v-if="allShow">{{ scope.row.content }}</div>
              </template>
            </el-table-column>
            <el-table-column label="发送状态" width="110">
              <template slot-scope="scope">
                <span>{{ statusDDStr(scope.row.status) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sendTime" label="发送时间" width="200"></el-table-column>
          </el-table>

          <div style="
                        padding: 20px 28px 30px;
                        text-align: right;
                        margin-bottom: 0px;
                      ">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 50, 100, 500, 1000]" :total="ddTotal" :page-size="ddSearchParams.size"
              :current-page="ddSearchParams.current" @size-change="handleSizeChangeDD"
              @current-change="handleCurrentChangeDD"></el-pagination>
          </div>
          <!-- <pagination @transferName="smsPaginationFunction" :total="smsTableTotalCount"></pagination> -->
        </div>
      </div>
    </div>

    <!-- 折线图 -->
    <div class="my_chart" style v-if="asideActive != 31 && selectIndex == 3 && rangeCountList.length !== 0">
      <div id="myChart" :style="{ width: '100%', height: '430px' }"></div>
    </div>

    <!--修改单价弹窗-->
    <el-dialog title="修改单价" :visible.sync="unitPriceView" width="30%">
      <div>
        <el-input type="number" v-model="unitPriceValue" clearable style="width: 90%"></el-input>
        <span style="width: 10%">元/条</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unitPriceView = false">取 消</el-button>
        <el-button type="primary" @click="updateUnitPrice">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 导出数据时间选择 -->
    <el-dialog title="导出数据" :visible.sync="exportTimeDialog" width="550px">
      <div>
        <span>请选择导出数据内容时间段</span>
        <div style="margin-top: 10px">
          <el-radio-group v-model="exportTimeType">
            <el-radio :label="0">
              <span>当前筛选数据</span>
            </el-radio>
            <el-radio :label="1">
              <span>自定义</span>
              <el-date-picker v-model="exportStartTime" type="datetime" placeholder="选择日期时间"
                :disabled="exportTimeType === 0" :picker-options="exportPickerOptions" size="small"
                value-format="yyyy-MM-dd HH:mm:ss" style="width: 120px; margin-left: 8px"></el-date-picker>
              <span style="padding: 0 15px">至</span>
              <el-date-picker v-model="exportEndTime" type="datetime" placeholder="选择日期时间"
                :disabled="exportTimeType === 0" :picker-options="exportPickerOptions" size="small"
                value-format="yyyy-MM-dd HH:mm:ss" style="width: 145px; font-size: 12px"></el-date-picker>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportTimeDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmExport">导 出</el-button>
      </span>
    </el-dialog>

    <!-- 挽回订单数弹框 -->
    <el-dialog :title="returnOrderTitle" :visible.sync="returnOrderDialog" width="1100px">
      <component :is="currentComponent" v-if="reload" :returnItem="returnItem"></component>
    </el-dialog>

    <!-- 导出数据 模态框 -->
    <el-dialog title="导出数据" :visible.sync="exportDialog" width="520px" style="min-width: 1200px">
      <template slot="title">
        <span>导出数据</span>
      </template>
      <div class="export-dialog-wrapper">
        <div class="title">
          <span>请选择导出数据内容</span>
          <span class="highlight-text">(按查询条件导出)</span>
        </div>
        <div class="checked-box">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0"></div>
          <el-checkbox-group v-model="checkedExportField" @change="handleCheckedExportChange">
            <el-checkbox v-for="exportField in exportFieldList" :label="exportField" :key="exportField"
              class="checked-item">{{
                exportField
              }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hd_exportDialog" size="small" style="width: 140px">导出</el-button>
        <el-button @click="exportDialog = false" size="small" style="width: 140px">取消</el-button>
      </div>
    </el-dialog>
    <!-- 生成报表 -->
    <generate :control = 'control'
          v-if="control" 
          @transData="(val) => (control = val)"
          @transData1 = 'getphone1'
    ></generate>


    <!-- 编辑任务 -->
    <page-condition v-if="pageConditionCom && detailFormData != null && !hasDongDongTask" :menuType="asideActive" :scorllY="topPX"
      :isAdd="false" :bodyHeight="bodyHeight" :postForms="detailFormData" @transferName="conditionBtnNone()"
      :drawer="true" :tid="tidActive" :taskTypeActive="taskTypeActive" :apiTypeActive="apiTypeActive"></page-condition>

    <!-- 新建任务 pageConditionCom  -->
    <page-condition v-if="pageConditionCom && detailFormData == null && !hasDongDongTask" :isAdd="true" :menuType="asideActive"
      :scorllY="topPX" :isShowTip="true" :tid="tidActive" :bodyHeight="bodyHeight" @transferName="conditionBtnNone()"
      :drawer="true" :taskTypeActive="taskTypeActive" :apiTypeActive="apiTypeActive"></page-condition>

       <!-- 编辑任务 -->
    <page-condition-new v-if="pageConditionCom && detailFormData != null && hasDongDongTask" :menuType="asideActive" :scorllY="topPX"
      :isAdd="false" :bodyHeight="bodyHeight" :postForms="detailFormData" @transferName="conditionBtnNone()"
      :drawer="true" :tid="tidActive" :taskTypeActive="taskTypeActive" :apiTypeActive="apiTypeActive"></page-condition-new>

    <!-- 新建任务 pageConditionCom  -->
    <page-condition-new v-if="pageConditionCom && detailFormData == null && hasDongDongTask" :isAdd="true" :menuType="asideActive"
      :scorllY="topPX" :isShowTip="true" :tid="tidActive" :bodyHeight="bodyHeight" @transferName="conditionBtnNone()"
      :drawer="true" :taskTypeActive="taskTypeActive" :apiTypeActive="apiTypeActive"></page-condition-new>
  </div>
</template>
<script>
import { getSmsSentRecordList, getRefundSendRecord, popCommentConfig, getNotpayremindRecordList } from "@/api/smsSentRecord";
import { updateUnitPrice } from "@/api/sellerController";
import { listDongDong } from "@/api/care/dongdong";
import { getRemind,getRemindMerge,getRemindByTimeMerge, page, getRemindByTime, openState, updateStatus, setRemindSort, delOrdersCare, orderCareInfo,exportPopCommentSmsEffect,exportNotpayremind } from "@/api/care/orderCare";
import {
  list,
  realTimeMonitoring,
  popCommentSmsEffect,
  updateSwitch,
  setSort,
  OrdersCarePopInfo,
  delOrdersCarePop,
} from "@/api/care/popCommentConfigController";
import { getRefundReminderConfigPage, setOpenState, delOrdersCareRefund, OrdersCareRefundInfo } from "@/api/care/refundReminderConfigController";

import { mapState, mapMutations, mapActions } from "vuex";
import topTitle from "@/components/top-title.vue";
import Pagination from "@/components/pagination.vue";
import returnOrderCom from "./chidrenCare/return-order-com.vue";
import pageCondition from "./page-condition.vue";
import pageConditionNew from "./page-condition-new.vue";
import { getSellerInfo } from "@/api/sellerController";
import iconBox from "./chidrenCare/iconBox";
import qs from "qs";
import IconBox from "./chidrenCare/iconBox.vue";
import iconBoxs from "./chidrenCare/iconBox1.vue";
import generate from '../../components/generate_report.vue'
const exportFieldOptions = ["买家昵称", "手机号码", "实付金额", "催付时间", "付款时间", "短信内容"];
export default {
  name: "page-order-care",
  components: {
    topTitle,
    Pagination,
    returnOrderCom,
    pageCondition,
    pageConditionNew,
    iconBox,
    IconBox,
    iconBoxs,
    generate
  },
  data() {
    return {
      control:false,
      activeOne: false,
      analysisType: 0, // 分析类型
      singleTasks: [], // 指定任务分析--任务列表
      taskId: '',
      conditionState: 0,
      topPX: "60px",
      bodyHeight: 0,
      detailFormData: null, // 编辑任务获取详情数据
      pageConditionCom: false, //编辑新建任务组件

      exportDialog: false, // 挽回订单-导出数据弹窗
      isIndeterminate: false,
      checkAll: true,
      checkedExportField: exportFieldOptions,
      exportFieldList: exportFieldOptions,

      returnOrderDialog: false, //挽回订单数弹框
      reload: true, //刷新组件
      currentComponent: returnOrderCom,
      returnItem: "",
      // 催付根据某个任务查询
      callSearchParams: {
        remindSellerConfigId: "",
      },

      exportTimeType: 0,
      exportStartTime: "",
      exportEndTime: "",
      // 往日监控数据分析-列表
      rangeCountList: [
        {
          sendTime: "2020-06-17",
          recordCount: "10", // 催付订单数
          count: "100", // 挽回订单数
          money: "100", // 挽回金额
          result: "100%", // 催付成功率
          roi: "1:10",
        },
        {
          sendTime: "2020-06-18",
          recordCount: "18", // 催付订单数
          count: "50", // 挽回订单数
          money: "25", // 挽回金额
          result: "100%", // 催付成功率
          roi: "1:10",
        },
        {
          sendTime: "2020-06-19",
          recordCount: "10", // 催付订单数
          count: "28", // 挽回订单数
          money: "36", // 挽回金额
          result: "100%", // 催付成功率
          roi: "1:10",
        },
      ],
      // 往日监控数据分析-均值
      calculateCuifuAvg: {
        recordCount: "11",
        evaluationResulCount: "13",
        orderPayment: "100",
        recordSuccessRate: "100%",
        roi: "1:10",
      },
      // 往日监控数据分析-汇总
      summaryDto: {
        recordCount: "11",
        evaluationResulCount: "13",
        orderPayment: "100",
        recordSuccessRate: "100%",
        roi: "1:10",
      },
      exportTimeDialog: false,
      talbeLoading3: false,
      pickerOptions: {
        //规定选择范围
        disabledDate(time) {
          return time.getTime() < Date.now() - 2.592e9 || time.getTime() > Date.now();
        },
      },
      exportPickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1.5552e10 || time.getTime() > Date.now();
        },
      },
      timeRangeView: true,
      rangeCountParams: {
        timeRange: "month",
        startTime: "",
        endTime: "",
      },
      unitPriceView: false,
      unitPriceValue: 0,
      todayData: [
        {
          name: "催付订单数",
          data: "",
          unit: "单",
          key: "recordCount",
        },
        {
          name: "挽回订单数",
          data: "",
          unit: "单",
          key: "count",
        },
        {
          name: "挽回金额",
          data: "",
          unit: "元",
          key: "money",
        },
        {
          name: "催付成功率",
          data: "",
          unit: "%",
          key: "result",
        },
        {
          name: "ROI",
          data: "0:00",
          unit: "",
          key: "roi",
        },
      ],
      todayData2: [
        {
          name: "催评通知数",
          data: "0",
          unit: "条",
          key: "count",
        },
        {
          name: "催评订单数",
          data: "0",
          unit: "单",
          key: "orderCnt",
        },
        {
          name: "催评成功数",
          data: "0",
          unit: "单",
          key: "successCnt",
        },
        {
          name: "催评成功率",
          data: "0",
          unit: "",
          key: "successRate",
        },
      ],
      todayData3: [
        {
          name: "发送订单数",
          data: "0",
          unit: "单",
          key: "sendOrderCount",
        },
        {
          name: "凑单付款订单数",
          data: "0",
          unit: "单",
          key: "mergeOrderPayCount",
        },
        {
          name: "凑单成交金额",
          data: "0",
          unit: "元",
          key: "mergeOrderMoney",
        },
        {
          name: "凑单成功率",
          data: "0",
          unit: "%",
          key: "successRate",
        }
      ],
      smsTableTotalCount: 0,
      allShow: false, // 信息是否全部显示
      talbeLoading1: false,
      smsTableList: [], //短信记录
      tableState: true,
      isDisabled: false, // 短信记录-查询时按钮禁止点击
      stautsOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "未发送",
        },
        {
          value: "1",
          label: "已发送",
        },
      ],
      /***
       * 短信记录-查询条件
       * */
      smsSearchParams: {
        sentTimeStart: "", //发送开始时间
        sentTimeEnd: "", //发送结束时间
        // comfrom: "", //信息来由
        pin: "", //买家昵称
        mobile: "", //手机号码
        status: "", //发送状态 0未发送 1已发送 2黑名单失败 4(10分钟内容重复) 3过滤重复发送 5无效号码 6中差评拦截 7退款拦截 ,
        orderId: "", //订单编号
        // softType: "1", //1(订单关怀,掌柜预警) 2(会员营销)
        content: "", //短信内容
        current: 1, //当前页
        size: 10, //每页大小
        // total: "",
      },
      /**
       * 任务列表查询记录
       */
      search1: {
        isOpen: "",
        searchKeyWord: "",
      },
      /**
       * 主页记录分页信息
       */
      paginationInfo: {
        tableCurrentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      //任务列表数据
      tableList: [
        // {
        //   taskName: "任务名称110",
        //   batchCount: "短信内容666",
        //   createTime: "2020-06-16 15:46:50",
        //   taskType: 1,
        //   sort: 2,
        //   openFlag: true,
        // },
      ],
      tableLoading: false,
      stateList: [
        {
          value: "",
          label: "-全部-",
        },
        {
          value: "1",
          label: "已开启",
        },
        {
          value: "2",
          label: "已关闭",
        },
      ],

      ddLoading: false,
      ddSearchParams:{
        pin:'',
        taskName:'',
        content:'',
        status:'',
        sendTimeStart:'',
        sendTimeEnd:'',
        current: 1, //当前页
        size: 10, //每页大小
      },
      ddTableList:[],
      ddTotal: 0,
      // 任务查询对应type
      taskType: [
        { api: "remind", name: "付款关怀", type: 1, templateTid: 1 },
        { api: "remind", name: "发货提醒", type: 2, templateTid: 2 },
        { api: "remind", name: "迟发提醒", type: 3, templateTid: 3 },
        { api: "remind", name: "完成提醒", type: 5, templateTid: 5 },
        { api: "remind", name: "取消提醒", type: 6, templateTid: 3625 },
        { api: "remind", name: "退货提醒", type: 7, templateTid: 3733 },
        { api: "remind", name: "派件提醒", type: 13, templateTid: 5666 },
        { api: "remind", name: "签收提醒", type: 14, templateTid: 1152 },
        {
          api: "remind",
          name: "下单关怀（货到）",
          type: 11,
          templateTid: 3626,
        },
        { api: "remind", name: "催付提醒", type: 8, templateTid: 8 },
        // { api: "remind", name: "二次催付", type: 12, templateTid: 2011 },
        { api: "remind", name: "预售尾款催付", type: 24 },

        { api: "pop", name: "自动催评", type: 1, templateTid: 2662 },
        { api: "pop", name: "好评感谢", type: 2, templateTid: 2663 },
        { api: "pop", name: "中差评安抚", type: 3, templateTid: 2664 },
        { api: "pop", name: "好评感谢（自营）", type: 2 },
        { api: "pop", name: "中差评安抚（自营）", type: 3 },

        { api: "refund", name: "申请退款", type: 1, templateTid: 2012 },
        { api: "refund", name: "同意退款", type: 2, templateTid: 2000 },
        { api: "refund", name: "拒绝退款", type: 3, templateTid: 2001 },
        { api: "refund", name: "退款成功", type: 4, templateTid: 2678 },

        { api: "remind", name: "入会关怀", type: 26, templateTid: 2678 },
        { api: "remind", name: "升级有礼", type: 27, templateTid: 2678 },
        { api: "remind", name: "降级关怀", type: 28, templateTid: 2678 },
        { api: "remind", name: "退会挽回", type: 29, templateTid: 2678 },
        { api: "remind", name: "积分变更通知", type: 30, templateTid: 2678 },

        { api: "remind", name: "智能凑单提醒", type: 31, templateTid: 2678 },
        { api: "remind", name: "购后入会提醒", type: 32, templateTid: 2678 },
        { api: "remind", name: "直播预售下单关怀", type: 33, templateTid: 2678 },
        { api: "remind", name: "直播下单关怀", type: 34, templateTid: 2678 },
      ],
      pickerOptions0: {
        disabledDate: (time) => {
          if (!this.smsSearchParams.sentTimeEnd) {
            return time.getTime() > Date.now();
          } else {
            let endTime = new Date(this.smsSearchParams.sentTimeEnd).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime - 365 * 24 * 3600 * 1000;

            return time.getTime() < minTime || time.getTime() > Date.now();
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (!this.smsSearchParams.sentTimeStart) {
            return time.getTime() > Date.now();
          } else {
            let startTime = new Date(this.smsSearchParams.sentTimeStart).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return time.getTime() < startTime || time.getTime() > Date.now() || time.getTime() > maxTime;
          }
        },
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (!this.rangeCountParams.endTime) {
            return time.getTime() > Date.now();
          } else {
            let endTime = new Date(this.rangeCountParams.endTime).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime - 365 * 24 * 3600 * 1000;

            return time.getTime() < minTime || time.getTime() > Date.now() - 8.64e7;
          }
        },
      },
      pickerOptions3: {
        disabledDate: (time) => {
          if (!this.rangeCountParams.startTime) {
            return time.getTime() > Date.now();
          } else {
            let startTime = new Date(this.rangeCountParams.startTime).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return time.getTime() < startTime || time.getTime() > Date.now() - 8.64e7 || time.getTime() > maxTime - 8.64e7;
          }
        },
      },
      pickerOptionsDD0: {
        disabledDate: (time) => {
          if (!this.ddSearchParams.sendTimeEnd) {
            return time.getTime() > Date.now();
          } else {
            let endTime = new Date(this.ddSearchParams.sendTimeEnd).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime - 365 * 24 * 3600 * 1000;

            return time.getTime() < minTime || time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsDD1: {
        disabledDate: (time) => {
          if (!this.ddSearchParams.sendTimeStart) {
            return time.getTime() > Date.now();
          } else {
            let startTime = new Date(this.ddSearchParams.sendTimeStart).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return time.getTime() < startTime || time.getTime() > Date.now() || time.getTime() > maxTime;
          }
        },
      },
      taskTypeActive: "", //当前type
      apiTypeActive: "", //请求接口类型
      tidActive: "",
      selectIndex: 1,
      // selectIndex: 3, // xxxxxxxxxxxxxxxxxxxxxx要上面的
      asideActive: 1, // 第几个侧边栏
      asideName: "常规催付", // 侧边栏的名字
      paths: "/orderCare/orderCare/expediting",
      openInfo: {
        popCommentConfigData: {},
        refundRemindConfigData: {},
        remindSellerConfigData: {},
      },
      smsType:"0"
    };
  },
  filters: {
    taskTypeStr(taskType) {
      return { 1: "持续开启", 2: "指定时间" }[taskType];
    },
    persistentOpenFlagStr(persistentOpenFlag) {
      return { true: "持续开启", false: "指定时间" }[persistentOpenFlag];
    },

    toPercentSign(percent) {
      var res = "";
      if (percent) {
        res = (percent * 100).toFixed(2) + "%";
      }
      return res;
    },
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
      roiTip: "roiTip",
      //   把city映射给currentCIty
    }),
    oUnitPrice(nVal, oVal) {
      return this.$store.getters.loginUserInfo.unitPrice;
    },
    payOrEvaluation() {
      if (this.asideActive == 13) {
        return "催评效果";
      }else if (this.asideActive == 31) {
        return "效果分析";
      } else {
        return "催付效果";
      }
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    returnOrderTitle() {
      return this.asideActive == 2 || this.asideActive == 3 || this.asideActive == 4 ? "催付成功数" : "催评成功数"
    },
    hasDongDong(){
      // 临时新加三个需要咚咚消息
      if([2,5,12].includes(this.asideActive)){
        return true;
      }else if(this.asideActive >= 26){
        return true;
      }else{
        return false;
      }
    },
    // 会员关怀
    isMemCare(){
      if([26,27,28,29,30].includes(this.asideActive)){
        return true;
      }else{
        return false;
      }
    },
    newSmsRecord(){
      if(this.asideActive >= 26){
        return true;
      }else{
        return false;
      }
    },
    hasDongDongTask(){
      if(this.asideActive >= 26){
        return false;
      }else{
        return false;
      }
    },
  },

  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      // console.log("watch==",to.path);
      this.selectIndex = 1;
      this.asideActive = this.getIndex(to.path);
      console.log(this.asideName, 95464676454567);
      this.init();
      // console.log("asideActive==", this.asideActive);
      if (this.asideActive === "") {
      }
    },
  },
  created() {
    this.asideActive = this.getIndex(this.$route.path);
    console.log(this.asideActive, 95464676454567);
    // 调用埋点接口
    // 筛选二级分类
    let cateName = ''
    if ([1, 2, 3, 4].includes(this.asideActive)) cateName = '下单催付'
    if ([5].includes(this.asideActive)) cateName = '付款关怀'
    if ([6, 7, 8, 9, 10, 11].includes(this.asideActive)) cateName = '物流提醒'
    if ([12].includes(this.asideActive)) cateName = '回款关怀'
    if ([13, 14, 15].includes(this.asideActive)) cateName = '评价关怀'
    if ([16, 17, 18, 19].includes(this.asideActive)) cateName = '退款关怀'
    if ([26, 27, 28, 29, 30].includes(this.asideActive)) cateName = '会员关怀'
    if ([31, 32, 33, 34 ].includes(this.asideActive)) cateName = '购物关怀'
    // console.log(cateName);
    this.buriedPoint(1, this.asideName, '订单关怀', cateName)
  },
  mounted() {
    // console.log(this.asideName);
    // console.log(this.$route);
    // 加载通知环节对应的下标
    this.smsSearchParams.sentTimeStart = this.getDateStr(-30) + " 00:00:00";
    this.smsSearchParams.sentTimeEnd = this.getDateStr(0) + " 23:59:59";

    this.ddSearchParams.sendTimeStart = this.getDateStr(-30) + " 00:00:00";
    this.ddSearchParams.sendTimeEnd = this.getDateStr(0) + " 23:59:59";
    // 用户单价信息
    getSellerInfo().then((res) => {
      this.unitPriceValue = res.data.unitPrice;
    });
    this.init();
    this.updataOpenState();
    if([2,3,4,13,31].includes(this.asideActive)){
      this.activeOne = true
      // 获取分析类型--指定任务分析--任务列表
      let param = {current:1,size:1000,taskType:8}
      if(this.asideActive == 2) param.taskType = 8;
      if(this.asideActive == 3) param.taskType = 12;
      if(this.asideActive == 4) param.taskType = 24;
      if(this.asideActive == 13){
        list({current:1,size:1000,type:1}).then(res=>{
          this.singleTasks = res.data.records
          this.taskId = this.singleTasks[0].id
        })
      }else if(this.asideActive == 31){
        page({current:1,size:1000,taskType:31}).then(res=>{
          this.singleTasks = res.data.records
          this.taskId = this.singleTasks[0].id
        })
      }else{
        page(param).then(res=>{
          this.singleTasks = res.data.records
          this.taskId = this.singleTasks[0].id
        })
      }
    }
    // this.$nextTick(()=>{
    //   this.drawLine();
    // })

    if (this.$route.query.industry) {
      this.selectIndex = 2
      // 我的使用策略跳转过来，发送时间取消默认状态，显示不填状态 
      // this.clearTime()
      // this.getSmsSentRecordList1()
    }
  },
  methods: {
    // 修改分析类型
    changeAnalysisType(val){
      // 触发今日催评&&数据监控
      this.analysisEffect()
      this.getRangeCount()
    },
    // 选择任务
    changeSingleTask(val){
      // 触发今日催评&&数据监控
      this.analysisEffect()
      this.getRangeCount()
    },
    statusStr(status) {
      return {
        0: "未发送",
        1: "已发送",
        2: "黑名单失败",
        4: "10分钟内容重复",
        3: "过滤重复发送",
        5: "无效号码",
        6: "中差评拦截",
        7: "退款拦截",
      }[status];
    },
    statusDDStr(status) {
      return {
        0: "未发送",
        1: "已发送",
        2: "发送失败"
      }[status];
    },
    /**
     *  获取距离当天时间的第X天的
     */
    getDateStr(val) {
      var day1 = new Date();
      day1.setDate(day1.getDate() + +val);
      var yy = day1.getFullYear(),
        mm = day1.getMonth() + 1,
        dd = day1.getDate(),
        hh = day1.getHours(),
        MM = day1.getMinutes(),
        ss = day1.getSeconds();
      if (parseInt(mm) < 10) {
        mm = "0" + mm;
      }
      if (parseInt(dd) < 10) {
        dd = "0" + dd;
      }
      return yy + "-" + mm + "-" + dd;
    },

    /**
     * 初始化
     */
    init() {
      // console.log(this.asideName);
      // 获取任务类型
      let type = this.taskType.find((item) => {
        return this.asideName == item.name;
      }).type;
      //api类型
      let api = this.taskType.find((item) => {
        return this.asideName == item.name;
      }).api;

      //短信模板tid
      let tid = this.taskType.find((item) => {
        return this.asideName == item.name;
      }).templateTid;
      this.taskTypeActive = type;
      this.apiTypeActive = api;
      this.tidActive = tid;
      // console.log(this.tidActive);
      this.getSmsSentRecordList(); //短信记录
      this.getOrdersCareList(); //任务列表
      this.getRangeCount(); //效果分析
    },
    conditionBtnNone() {
      this.paginationInfo.tableCurrentPage = 1;
      // this.getOrdersCare();
      // this.conditionState = 0;
      this.getOrdersCareList();
      setTimeout(() => {
        this.pageConditionCom = false;
      }, 500);
    },

    // 创建任务
    newBtn() {
      console.log("新建任务==", this.asideName, this.apiTypeActive);
      const height = document.documentElement.clientHeight || document.body.clientHeight;
      if (this.topPX == "60px") {
        this.bodyHeight = height - 60;
      } else {
        this.bodyHeight = height - 60;
      }
      this.pageConditionCom = true;

      // 设置回显数据为空
      this.detailFormData = null;
    },
    hd_exportDialog() {
      let self = this;
      self.exportDialog = false;
    },

    //
    handleCheckAllChange(val) {
      this.checkedExportField = val ? exportFieldOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedExportChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.exportFieldList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.exportFieldList.length;
    },
    // 催付效果-导出
    confirmExport() {
      this.exportTimeDialog = false;
    },
    //往日数据导出
    exportData() {
      this.control = true
    },
    getphone1(val){
      var rangeCountParams = JSON.parse(JSON.stringify(this.rangeCountParams));
      if (rangeCountParams.startTime) {
        rangeCountParams.startTime = rangeCountParams.startTime + " 00:00:00";
      }
      if (rangeCountParams.endTime) {
        rangeCountParams.endTime = rangeCountParams.endTime + " 00:00:00";
      }
      if(this.activeOne){
        rangeCountParams.analysisType = this.analysisType
        rangeCountParams.taskId = this.taskId
      }
      if(!rangeCountParams.analysisType) {
        delete rangeCountParams.taskId
      }
      rangeCountParams.exportRemark = val
      console.log(qs.stringify(rangeCountParams));
      if (this.apiTypeActive == "pop") {
        exportPopCommentSmsEffect(qs.stringify(rangeCountParams)).then((res)=>{
          if(res.code==1){
            this.control = true
          }else{
            this.$message.error(res.message)
          }
        })
        // url = "/jd-yusms/popCommentConfig/exportPopCommentSmsEffect?" + qs.stringify(rangeCountParams);
      } else {
        rangeCountParams.type = this.taskTypeActive;
        // 催付提醒添加消息类型
        if((this.asideActive == 2) && this.smsType){
          rangeCountParams.smsType = Number(this.smsType)
        }
        exportNotpayremind(qs.stringify(rangeCountParams)).then((res)=>{
          if(res.code==1){
            this.control = true
          }else{
            this.$message.error(res.message)
          }
        })
      }
    },
    //  切换到效果分析模块
    analysisEffect() {
      // 催评模块
      // 今日信息
      let param = {
        analysisType:this.analysisType,
      }
      if(param.analysisType == 1){
        param.taskId = this.taskId
      }
      // 催付提醒添加消息类型
      if((this.asideActive == 2) && this.smsType){
        param.smsType = Number(this.smsType)
      }
      if (this.asideActive == 13) {
        realTimeMonitoring(param).then(({ data }) => {
          // console.log(data);
          this.todayData2.map((item) => {
            item.data = data[item.key];
          });
        });
      } else if(this.asideActive == 31){
        getRemindMerge(param).then(res=>{
          if(res.code == 1){
            let data = res.data;
            this.todayData3.map((item) => {
              item.data = data[item.key];
            });
          }
        })
      }else {
        getRemind(this.taskTypeActive,param).then(({ data }) => {
          this.todayData.map((item) => {
            item.data = data[item.key];
          });
        });
      }

      if (!this.talbeLoading3) {
        this.drawLine();
      }
    },
    // 折线图-画线
    drawLine() {
      // console.log("开始画线==");
      let self = this;
      const rangeCountList = this.rangeCountList;
      let [dateList, orderPaymentList, orderPayedCountList, recordCountList] = [[], [], [], []];

      if (this.asideActive == 13) {
        rangeCountList.forEach(function (item) {
          dateList.push(item.makeEvaluationTime); //日期
          recordCountList.push(item.count); //催评通知数
          orderPayedCountList.push(item.orderCnt); //催评订单数
          orderPaymentList.push(item.orderSuccessCnt); //催评成功数
        });
      } else {
        rangeCountList.forEach(function (item) {
          dateList.push(item.sendTime); //日期
          recordCountList.push(item.recordCount); //催付订单数
          orderPayedCountList.push(item.count); //挽回订单数
          orderPaymentList.push(item.money); //挽回金额
        });
      }

      // 催付订单数 挽回订单 挽回金额 日期
      let yAxisName;
      let seriesItem = [];
      let legendDatas = [];
      if (this.asideActive == 13) {
        yAxisName = "";
        seriesItem = [
          {
            name: "催评通知数",
            data: recordCountList,
            type: "line",
            smooth: true,
            color: ["#FE4D45"],
          },
          {
            name: "催评订单数",
            data: orderPayedCountList,
            type: "line",
            smooth: true,
            color: ["#4878FF"],
          },
          {
            name: "催评成功数",
            data: orderPaymentList,
            type: "line",
            smooth: true,
            color: ["#49C568"],
          },
        ];
        legendDatas = ["催评通知数", "催评订单数", "催评成功数"];
      } else {
        yAxisName = "";
        seriesItem = [
          {
            name: "催付订单",
            data: recordCountList,
            type: "line",
            smooth: true,
            color: ["#FE4D45"],
          },
          {
            name: "挽回订单",
            data: orderPayedCountList,
            type: "line",
            smooth: true,
            color: ["#4878FF"],
          },
          {
            name: "挽回金额",
            data: orderPaymentList,
            type: "line",
            smooth: true,
            color: ["#49C568"],
          },
        ];
        legendDatas = ["催付订单", "挽回订单", "挽回金额"];
      }

      self.$nextTick(() => {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById("myChart"), "light");
        // 绘制图表
        window.onresize = myChart.resize;
        myChart.setOption({
          legend: {
            data: legendDatas,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          xAxis: {
            name: "日期",
            type: "category",
            data: dateList,
            axisLine: {
              lineStyle: {
                color: "#838383",
              },
            },
          },
          yAxis: {
            name: yAxisName,
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#666666",
              },
            },
            axisLine: {
              //y轴
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            splitLine: {
              //网格线
              show: true,
              color: "#999",
            },
          },
          series: seriesItem,
        });
      });
    },
    //常规催付 往日数据监控分析 挽回订单数
    returnOrderNum(item, type) {
      // console.log(item, type);
      this.returnItem = {
        subTime: item.makeEvaluationTime || item.sendTime,
        type: this.taskTypeActive,
        apiTypeActive: this.apiTypeActive,
        analysisType: this.analysisType,
        taskId: this.taskId
      };
      // console.log(this.returnItem);
      this.returnOrderDialog = true;
      return;
    },
    /**
     *搜索数据
     */
    seacherResultCare() {
      this.getRangeCount();
    },
    resetBtn3() {
      this.timeRangeView = true;
      this.rangeCountParams = {
        timeRange: "month",
        startTime: "",
        endTime: "",
      };
      this.getRangeCount();
    },
    clearTime2() {
      this.rangeCountParams.startTime = "";
      this.rangeCountParams.endTime = "";
    },
    /***
     * 效果分析 往日数据监控分析
     * */
    getRangeCount() {
      this.talbeLoading3 = true;
      // 自动催评效果分析
      if (this.asideActive == 13) {
        let self = this;
        let params = {
          endTime: self.rangeCountParams.endTime ? self.rangeCountParams.endTime + " 00:00:00" : "",
          startTime: self.rangeCountParams.startTime ? self.rangeCountParams.startTime + " 00:00:00" : "",
          time_range: self.rangeCountParams.timeRange,
          analysisType: this.analysisType,
        };
        if(params.analysisType == 1){
          params.taskId = this.taskId
        }
        popCommentSmsEffect(params).then(({ data }) => {
          this.talbeLoading3 = false;

          this.rangeCountList = data.data || [];

          this.calculateCuifuAvg = data.avgResult || {}; //均值

          this.summaryDto = data.totalResult || {}; // 汇总
          if (this.selectIndex == 3) {
            this.drawLine();
          }
        });
      }
      // 催付效果分析
      else if (this.asideActive == 2 || this.asideActive == 3 || this.asideActive == 4) {
        let self = this;
        let params = {
          endTime: self.rangeCountParams.endTime ? self.rangeCountParams.endTime + " 00:00:00" : "",
          startTime: self.rangeCountParams.startTime ? self.rangeCountParams.startTime + " 00:00:00" : "",
          timeRange: self.rangeCountParams.timeRange,
          type: this.taskTypeActive,
          analysisType: this.analysisType
        };
        if(this.smsType){
          params.smsType = Number(this.smsType)
        }
        if(params.analysisType == 1){
          params.taskId = this.taskId
        }
        for (var i in params) {
          if (params[i] === "") {
            delete params[i];
          }
        }
        // getRemindByTime(params).then(({data})=>{
        getRemindByTime(params).then((res) => {
          // console.log(res);
          this.talbeLoading3 = false;
          if (res.code == "1") {
            var data = res.data;
            // if(data.dataList.length !== 0){
            this.rangeCountList = data.dataList;
            // }

            this.calculateCuifuAvg = data.avgResult; //均值

            this.summaryDto = data.totalResult; // 汇总
            // 画图表
            if (this.selectIndex == 3) {
              this.drawLine();
            }
          }
        });
      }else if(this.asideActive == 31){
        let self = this;
        let params = {
          endTime: self.rangeCountParams.endTime ? self.rangeCountParams.endTime + " 00:00:00" : "",
          startTime: self.rangeCountParams.startTime ? self.rangeCountParams.startTime + " 00:00:00" : "",
          timeRange: self.rangeCountParams.timeRange,
          analysisType: this.analysisType,
        };
        if(params.analysisType == 1){
          params.taskId = this.taskId
        }
        for (var i in params) {
          if (params[i] === "") {
            delete params[i];
          }
        }
        getRemindByTimeMerge(params).then((res) => {
          this.talbeLoading3 = false;
          if (res.code == "1") {
            var data = res.data;
            this.rangeCountList = data.dataList;
            this.summaryDto = data.totalResult || {}; // 汇总
          }
        });
      }
    },

    isInMonth() {
      // console.log(this.rangeCountParams.endTime);
      if (Math.abs(new Date().getTime() - new Date(this.rangeCountParams.endTime).getTime()) > 30 * 24 * 60 * 60 * 1000) {
        this.rangeCountParams.endTime = this.moment(new Date()).format("YYYY-MM-DD");
      }
      if (Math.abs(new Date().getTime() - new Date(this.rangeCountParams.startTime).getTime()) > 30 * 24 * 60 * 60 * 1000) {
        // this.rangeCountParams.startTime = this.moment(
        //   new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
        // ).format("YYYY-MM-DD");
      }
    },
    selectTimeRange() {
      if (this.rangeCountParams.timeRange === "range") {
        // 自定义
        this.timeRangeView = false;
      } else {
        this.timeRangeView = true;
        this.rangeCountParams.startTime = "";
        this.rangeCountParams.endTime = "";
        // this.getRangeCount();
      }
    },
    // 修改单价
    updateUnitPrice() {
      this.unitPriceView = false;
      updateUnitPrice(0,this.unitPriceValue).then((res) => {
        if (res.code === 1) {
          this.$message.success("修改成功");
        }
      });
    },

    /***
     * 获取关怀任务列表
     * */
    getOrdersCareList() {
      this.tableLoading = true;
      // console.log(this.asideName);
      // 获取任务类型
      let type = this.taskType.find((item) => {
        return this.asideName == item.name;
      }).type;

      // 查询参数
      let params = {
        ...this.search1,
        type,
        size: this.paginationInfo.pageSize,
        current: this.paginationInfo.tableCurrentPage,
      };
      for (var i in params) {
        if (params[i] == "") {
          delete params[i];
        }
      }
      // console.log(type,this.apiTypeActive);
      // 评价任务列表

      switch (this.apiTypeActive) {
        case "pop":
          list(params).then(({ data }) => {
            this.tableLoading = false;
            this.tableList = data.records;
            this.paginationInfo.totalCount = Number(data.total);
          });
          break;
        case "refund":
          getRefundReminderConfigPage({
            keyWord: this.search1.searchKeyWord,
            ...params,
          }).then(({ data }) => {
            this.tableLoading = false;
            data.records.map((item) => {
              item.updateTime = item.operateTime;
            });
            this.tableList = data.records;
            this.paginationInfo.totalCount = Number(data.total);
          });
          break;
        case "remind":
          if (params.isOpen == 1) {
            params.openFlag = true;
          } else if (params.isOpen == 2) {
            params.openFlag = false;
          }
          delete params[("isOpen", "type")];
          page({ ...params, taskType: type }).then(({ data }) => {
            this.tableLoading = false;
            data.records.forEach((i) => {
              if (i.openFlag) {
                i.isOpen = 1;
              } else {
                i.isOpen = 2;
              }
            });
            this.tableList = data.records;
            this.paginationInfo.totalCount = Number(data.total);
          });
          break;
      }
    },
    // /***
    //  * 短信记录分页函数
    //  * */
    // async smsPaginationFunction(event) {
    //   console.log(event);
    //   this.smsSearchParams.current = event.current;
    //   this.smsSearchParams.size = event.pageSize;
    //   await this.getSmsSentRecordList();
    // },
    handleSizeChangeSms(val) {
      this.smsSearchParams.size = val;
      this.smsSearchParams.current = 1;
      this.getSmsSentRecordList();
    },
    handleCurrentChangeSms(val) {
      this.smsSearchParams.current = val;
      this.getSmsSentRecordList();
    },
    /*
     * 短信是否是全部显示
     * */
    allShowBtn(type) {
      if (type == 1) {
        this.allShow = true;
      } else {
        this.allShow = false;
      }
    },
    clearTime() {
      this.smsSearchParams.sentTimeStart = "";
      this.smsSearchParams.sentTimeEnd = "";
      this.ddSearchParams.sendTimeStart = "";
      this.ddSearchParams.sendTimeEnd = "";

    },

    /***
     * 短信记录-查询
     * */
    getSmsSentRecordList1() {
      this.smsSearchParams.current = 1;
      this.getSmsSentRecordList();
    },
    getSmsSentRecordList() {
      this.talbeLoading1 = true;
      let params = { ...this.smsSearchParams };
      // console.log(params);
      // return
      for (var i in params) {
        if (params[i] == "") {
          delete params[i];
        }
      }
      // 评价关怀
      console.log(this.apiTypeActive, 855555);
      switch (this.apiTypeActive) {
        case "pop":
          // console.log(params);
          params.sendContent = params.content;
          params.sendStartTime = params.sentTimeStart;
          params.sendEndTime = params.sentTimeEnd;
          delete params["content"];
          delete params["sentTimeStart"];
          delete params["sentTimeEnd"];
          let comfrom = this.asideName;
          if (this.asideName == "好评感谢（自营）") {
            comfrom = "好评感谢";
          } else if (this.asideName == "中差评安抚（自营）") {
            comfrom = "中差评安抚";
          }
          popCommentConfig({
            comfrom,
            ...params,
          }).then(({ data }) => {
            // console.log(res);
            data.records.forEach((i) => {
              i.content = i.sendContent;
            });
            this.smsTableList = data.records;
            this.smsTableTotalCount = Number(data.total);
            this.talbeLoading1 = false;
          });
          break;
        case "refund":
          params.sendStartTime = params.sentTimeStart;
          params.sendEndTime = params.sentTimeEnd;
          delete params.sentTimeStart;
          delete params.sentTimeEnd;
          getRefundSendRecord({
            ...params,
            comfrom: this.asideName,
          }).then(({ data }) => {
            // console.log(res);
            data.records.forEach((i) => {
              i.content = i.sendContent;
            });
            this.smsTableList = data.records;
            this.smsTableTotalCount = Number(data.total);
            this.talbeLoading1 = false;
          });
          break;
        case "remind":
          if (this.taskTypeActive == 8 || this.taskTypeActive == 12 || this.taskTypeActive == 24) {
            let type = this.taskTypeActive == 8 ? 1 : 2;
            if (this.taskTypeActive == 24) {
              type = 3;
            }
            getNotpayremindRecordList({
              type,
              sendStatus: params.status,
              sendTimeStart: params.sentTimeStart,
              sendTimeEnd: params.sentTimeEnd,
              pin: params.pin,
              content: params.content,
              orderId: params.orderId,
              current: params.current,
              size: params.size,
              // ...params,
            }).then(({ data }) => {
              if (data.records) {
                data.records.forEach((item) => {
                  if (item.type == 1) {
                    item.comfrom = "催付提醒";
                    item.sendStatus = 1;
                  }
                  if (item.type == 2) {
                    item.comfrom = "二次催付";
                    item.sendStatus = 1;
                  } else if (item.type == 3) {
                    item.sendStatus = 1;
                    item.comfrom = "预售尾款催付";
                  }
                });
              }
              this.smsTableList = data.records;
              this.smsTableTotalCount = Number(data.total);
              this.talbeLoading1 = false;
            });
          } else {
            getSmsSentRecordList({
              taskType: this.taskTypeActive,
              ...params,
            }).then(({ data }) => {
              // console.log(res);
              this.smsTableList = data.records;
              this.smsTableTotalCount = Number(data.total);
              this.talbeLoading1 = false;
            });
          }
          break;
      }
      // 退款关怀
    },
    // 重置短信记录查询条件
    resetBtn1() {
      this.smsSearchParams.pin = "";
      this.smsSearchParams.orderId = "";
      this.smsSearchParams.status = "";
      this.smsSearchParams.mobile = "";
      this.smsSearchParams.sentTimeStart = "";
      this.smsSearchParams.sentTimeEnd = "";
      this.smsSearchParams.content = "";
      this.smsSearchParams.current = 1;
      this.smsSearchParams.current = 1;
      this.smsSearchParams.size = 10;
      // console.log(this.paginationInfo);
      // this.paginationInfo={
      //   tableCurrentPage: 1,
      //   pageSize: 10,
      // },
      this.getSmsSentRecordList();
    },
    /**
     * 咚咚记录
     */
     queryDdRecordList(){
      this.ddSearchParams.current = 1;
      this.getDdRecordList();
     },
     resetBtndd(){
      
      this.ddSearchParams.pin = '';
      this.ddSearchParams.taskName = '';
      this.ddSearchParams.content = '';
      this.ddSearchParams.status = '';
      this.ddSearchParams.sendTimeStart = '';
      this.ddSearchParams.sendTimeEnd = '';
      this.queryDdRecordList();
     },
     getDdRecordList(){
      this.ddLoading = true;
      let comfrom = this.asideName
      if(comfrom == "付款关怀"){ 
        comfrom = "付款提醒"
      }
      listDongDong({...this.ddSearchParams,comfrom}).then(res=>{
        this.ddLoading = false;
        if(res.code == 1){
          this.ddTableList = res.data.records;
          this.ddTotal = res.data.total
        }else{
          this.$message.error(res.message);
        }
       
      })
     },
     handleSizeChangeDD(val){
      this.ddSearchParams.size = val;
      this.getDdRecordList();
     },
     handleCurrentChangeDD(val){
      this.ddSearchParams.current = val;
      this.getDdRecordList();
     },
    // 优先级修改
    handleChange(val) {
      // console.log(val);
      if (val.sort !== undefined) {
        switch (this.apiTypeActive) {
          case "pop":
            setSort({
              configId: val.id,
              sort: val.sort,
            }).then((res) => {
              res.code === 1 ? this.$message.success("操作成功") : this.$message.error(res.message);
            });
            break;
          case "refund":
            this.$http
              .post("/refundReminderConfig/openState", null, {
                params: {
                  id: val.id,
                  sort: val.sort,
                },
              })
              .then((res) => {
                // console.log(res);
                res.data.code === 1 ? this.$message.success("操作成功") : this.$message.error(res.data.message);
              });
            break;
          case "remind":
            setRemindSort({
              configId: val.id,
              sort: val.sort,
            }).then((res) => {
              res.code === 1 ? this.$message.success("操作成功") : this.$message.error(res.message);
            });
        }
      } else {
        this.$message.error("优先级不允许为空");
      }
    },

    //更新所有模块开启状态
    updataOpenState() {
      openState().then((res) => {
        this.openInfo = res.data;
      });
    },
    // 单个任务开启状态改变
    changeSwitch(val) {
      // console.log(val);
      let isOpen;

      switch (this.apiTypeActive) {
        case "pop":
          updateSwitch({
            configId: val.id,
            isOpen: val.isOpen,
          }).then((res) => {
            res.code === 1 ? this.$message.success("操作成功") : this.$message.error(res.message);
            this.updataOpenState();
            this.getOrdersCareList();
          });

          break;
        case "refund":
          this.$http
            .post("/refundReminderConfig/openState", null, {
              params: {
                id: val.id,
                isOpen: val.isOpen,
              },
            })
            .then((res) => {
              // // console.log(res);
              res.data.code === 1 ? this.$message.success("操作成功") : this.$message.error(res.data.message);
              this.updataOpenState();
              this.getOrdersCareList();
            });
          break;
        case "remind":
          updateStatus({
            configId: val.id,
            state: !val.openFlag,
          }).then((res) => {
            res.code === 1 ? this.$message.success("操作成功") : this.$message.error(res.message);
            this.updataOpenState();
            this.getOrdersCareList();
          });
      }
      return;
    },

    /** *
     * 编辑任务
     * */
    editOrderCare(row) {
      if (this.apiTypeActive == "remind") {
        // todo： 二次催付编辑回显
        orderCareInfo(row.id).then((res) => {
          // console.log(res);
          //列表字符串转对象 回显
          let data = res.data;
          console.log("data...", data);
          if(data.memberSelect==null){
            data.memberSelect = 0
          }
          if(data.memberSelectLevel == null) {
            data.memberSelectLevel = ['']
          }
          this.detailFormData = {
            dayLimit:data.dayLimit,
            sellerRemarkType:data.sellerRemarkType,
            buyerRemarkType:data.buyerRemarkType,
            id: data.id,
            type: data.type,
            taskName: data.taskName, //任务名称
            taskType: data.persistentOpenFlag ? 0 : 1, //任务时间类型
            taskStartTime: data.taskAllowRunStartTime ? data.taskAllowRunStartTime : "",
            taskEndTime: data.taskAllowRunEndTime ? data.taskAllowRunEndTime : "",
            sendCondition: data.condit,
            sendUnitTime: "0",
            sendUnitTime2: "0",
            moneyPayEndTime: data.bargainTimeEnd,
            moneyPayStartTime: data.bargainTimeStart,
            // 尾款支付时间
            balanceTimeStart: data.balanceTimeStart,
            balanceTimeEnd: data.balanceTimeEnd,
            // 尾款结束时间
            balancePaymentRemindEndMinutes: data.balancePaymentRemindEndMinutes,
            // 发送时段
            startRemindTime: data.remindSendStart,
            endRemindTime: data.remindSendEnd,
            remindSendType: data.remindSendType == "0" ? "1" : "2",
            // 午休
            isLunchBreak: data.filterSendType == 1 ? true : false,
            startLunchBreak: data.startFilterSendConfig,
            endLunchBreak: data.endFilterSendConfig,
            // 发送条件
            isOrderMoney: data.orderMoneyFilterType == "1" ? true : false,
            startOrderMoney: data.orderMoneyStart,
            endOrderMoney: data.orderMoneyEnd,
            isProductNum: data.wareNumberConfigType == "1" ? true : false,
            startProductNum: data.startWareNumberConfig,
            endProductNum: data.endWareNumberConfig,
            isSellerRemark: data.venderRemarkFilterType == "1" ? true : false,
            sellerRemark: data.venderRemarkConfig,
            isSellerRemarkSend: data.sellerRemarkIsSend ? "1" : "0",
            isBuyerMessage: data.buyerRemarkFilterType == "1" ? true : false,
            buyerMessage: data.buyerRemarkConfig,
            isBuyerMessageSend: data.buyerRemarkIsSend ? "1" : "0",
            logisticsNum: data.sellerCode,
            tailNumber: data.tailNumber,
            ztExpressPhone: data.ztExpressPhone,
            // 过滤设置
            filterCondition: [],
            //运单号
            shipmentNum: data.waybillType + "",
            // 选择地区
            areaType: data.areaType + "",
            zip: data.provinceCodes ? data.provinceCodes : [],
            payType: data.payTypeFilterData ? data.payTypeFilterData.split(",") : [],
            // 选择商品
            isAllItem: data.isAllItem + "",
            // itemList: data.wareList,
            itemList: data.itemList,
            content: data.contnet,
            templateId: data.templateId,
            transformUrl: data.transformUrl ? data.transformUrl : "",
            url: data.url ? data.url : "",
            memberSelect: !data.memberSelect ? "0" : data.memberSelect + '',
            memberSelectLevel: !data.memberSelectLevel ? [''] : data.memberSelectLevel.split(','),
            // 催付提醒
            isOpenSecond: data.isOpenSecond,
            contnet2: (data.secondConfigObj && !!data.secondConfigObj.contnet) ? data.secondConfigObj.contnet : '',
            secondConfigObj: {
              condit: (data.secondConfigObj && !!data.secondConfigObj.condit) ? data.secondConfigObj.condit : '',
              templateId: (data.secondConfigObj && !!data.secondConfigObj.templateId) ? data.secondConfigObj.templateId : '',
            },
            sendCondCondit: (data.secondConfigObj && !!data.secondConfigObj.condit) ? data.secondConfigObj.condit : '',
            secondUnitTimeType: "0",
            isSendSms: data.isSendSms ,
            isSendDongDong: data.isSendDongDong ,
            waiter: data.waiter ,
            dongDongContent: data.dongDongContent ,
            levelChange: data.levelChange ,
            pointChange: data.pointChange ,
            intelligentSkuId: data.intelligentSkuId ,
          };
          if(data.secondConfigObj){
            this.detailFormData.secondConfigObj.isSendSms = data.secondConfigObj.isSendSms
            this.detailFormData.secondConfigObj.isSendDongDong = data.secondConfigObj.isSendDongDong
            this.detailFormData.secondConfigObj.waiter = data.secondConfigObj.waiter
            this.detailFormData.secondConfigObj.dongDongContent = data.secondConfigObj.dongDongContent
          }
          if (data.filterBlacklistType) {
            this.detailFormData.filterCondition.push("2");
          }
          if (data.sendRequencyType == 1) {
            this.detailFormData.filterCondition.push("1");
          }
          if (data.otherOrderAlreadyPaymentSend) {
            this.detailFormData.filterCondition.push("3");
          }
          this.detailFormData.id = row.id;
          const height = document.documentElement.clientHeight || document.body.clientHeight;
          if (this.topPX == "60px") {
            this.bodyHeight = height - 60;
          } else {
            this.bodyHeight = height - 60;
          }
          this.pageConditionCom = true;
          // document.body.parentNode.style.overflowY = "hidden";
          //   this.conditionState = true;
        });
      }
      // 评价关怀回显
      else if (this.apiTypeActive == "pop") {
        OrdersCarePopInfo(row.id).then((res) => {
          // console.log(res);
          //列表字符串转对象 回显
          let data = res.data;

          console.log(".......................v", data);
          this.detailFormData = {
            dayLimit:data.dayLimit,
            sellerRemarkType:data.sellerRemarkType,
            buyerRemarkType:data.buyerRemarkType,
            id: data.id,
            type: data.type,
            taskName: data.taskName, //任务名称
            taskType: data.taskType == 1 ? 0 : 1, //任务时间类型
            taskStartTime: data.appointTimeStart,
            taskEndTime: data.appointTimeEnd, //发送时间
            sendCondition: data.sendCondit + "",
            sendUnitTime: "0",
            memberSelect: !data.memberSelect ? "0" : data.memberSelect + '',
            memberSelectLevel: !data.memberSelectLevel ? [''] : data.memberSelectLevel.split(','),
            // 发送时段
            startRemindTime: data.startSendtimeConfig + ":00",
            endRemindTime: data.endSendtimeConfig + ":00",
            remindSendType: data.extnoSendType + "",
            // 午休
            isLunchBreak: data.lunchTimeType == 1 ? true : false,
            startLunchBreak: data.lunchTimeStart ? data.lunchTimeStart + ":00" : "",
            endLunchBreak: data.lunchTimeEnd ? data.lunchTimeEnd + ":00" : "",
            // 实付金额
            isOrderMoney: data.orderPaymentFilterType == 2 ? true : false,
            startOrderMoney: data.startOrderPayment,
            endOrderMoney: data.endOrderPayment,
            // 商品数量
            isProductNum: data.goodsNumFilterType == 1 ? true : false,
            startProductNum: data.goodsNumStart,
            endProductNum: data.goodsNumEnd,
            // 商家备注
            isSellerRemark: data.filterVenderRemarkType == 1 ? false : true,
            sellerRemark: data.filterVenderRemark,
            isSellerRemarkSend: data.sellerRemarkIsSend ? "1" : "0",
            // 买家备注
            isBuyerMessage: data.filterBuyerRemarkType == 1 ? false : true,
            buyerMessage: data.filterBuyerRemark,
            isBuyerMessageSend: data.buyerRemarkIsSend ? "1" : "0",

            // 过滤设置
            filterCondition: [],
            // 运单号
            shipmentNum: data.waybillFilterType - 1 + "",
            // 针对评分
            selectStart: data.score ? data.score.split(",") : [],
            isAllItem: "0",
            // itemList: data.popCommentItemList,
            itemList: data.itemList,
            // areaType:data.appointAreaFlag?"3":"0",
            payType: data.payType == 0 ? [] : data.payType.split(","),
            content: data.content,
            // // 选择地区
            // areaType: data.provinceFilterType ? "3" : "0",
            areaType: data.areaType + "",

            templateId: data.templateId, //官方模板id

            runTime: data.runTime ? data.runTime : "", //Tag:自动催评增加 runTime 参数(21/9/15)
          };
          // 屏蔽黑名单
          if (data.blackmobileFilterType == 1) {
            this.detailFormData.filterCondition.push("2");
          }
          //同1买家
          if (data.samedayFilterSetting) {
            this.detailFormData.filterCondition.push("1");
          }
          // 屏蔽中差评
          if (data.badReviewFilterSetting) {
            this.detailFormData.filterCondition.push("4");
          }
          // 屏蔽退过款客户
          if (data.refundFilterSetting) {
            this.detailFormData.filterCondition.push("5");
          }
          if (data.itemFilterType == 2) {
            this.detailFormData.isAllItem = "2";
          }
          if (data.itemFilterType == 1) {
            this.detailFormData.isAllItem = "0";
          }
          if (data.itemFilterType == 3) {
            this.detailFormData.isAllItem = "1";
          }
          if (data.provinceFilterType && data.popCommentProvinceList) {
            this.detailFormData.zip = data.popCommentProvinceList;
          } else {
            this.detailFormData.zip = [];
          }
          // return
          const height = document.documentElement.clientHeight || document.body.clientHeight;
          if (this.topPX == "60px") {
            this.bodyHeight = height - 60;
          } else {
            this.bodyHeight = height - 60;
          }
          this.pageConditionCom = true;
        });
      } else {
        OrdersCareRefundInfo({
          id: row.id,
          type: this.taskTypeActive,
        }).then((res) => {
          // console.log(res);
          //列表字符串转对象 回显
          let data = res.data;
          this.detailFormData = {
            dayLimit:data.dayLimit,
            sellerRemarkType:data.sellerRemarkType,
            buyerRemarkType:data.buyerRemarkType,
            id: data.id,
            type: data.type,
            taskName: data.taskName, //任务名称
            taskType: data.taskType == 1 ? 0 : 1, //任务时间类型
            taskStartTime: data.taskStartTime,
            taskEndTime: data.taskEndTime,
            // 发送时段
            startRemindTime: data.startSendtimeConfig + ":00",
            endRemindTime: data.endSendtimeConfig + ":00",
            remindSendType: data.extnoSendType == "0" ? "1" : "2",
            // 午休
            isLunchBreak: data.openLunchFlag,
            startLunchBreak: data.lunchStartTime ? data.lunchStartTime + ":00" : "",
            endLunchBreak: data.lunchEndTime ? data.lunchEndTime + ":00" : "",
            // 实付金额
            isOrderMoney: data.orderPaymentFilterType == 2 ? true : false,
            startOrderMoney: data.startOrderPayment,
            endOrderMoney: data.endOrderPayment,
            // 商品数量
            isProductNum: data.wareCountFlag,
            startProductNum: data.wareCountDownLimit,
            endProductNum: data.wareCountUpLimit,
            // 商家备注
            isSellerRemark: data.filterVenderRemarkType == "2" ? true : false,
            sellerRemark: data.filterVenderRemark,
            isSellerRemarkSend: data.sellerRemarkIsSend ? "1" : "0",
            // 买家备注
            isBuyerMessage: data.buyerRemarkFlag,
            buyerMessage: data.buyerRemarkKeywordCondition,
            isBuyerMessageSend: data.buyerRemarkIsSend ? "1" : "0",
            // 过滤设置
            filterCondition: [],
            // 运单号
            shipmentNum: data.waybillFilterType - 1 + "",
            isAllItem: "0",
            itemList: data.refundItemConfigList,
            // itemList: data.itemList,
            // areaType: data.appointAreaType == 0 ? "0" : "3",
            areaType: data.areaType + "",
            zip: data.provinces,
            payType: data.payType == 0 ? [] : data.payType.split(","),
            templateId: data.templateId,
            memberSelect: !data.memberSelect ? "0" : data.memberSelect + '',
            memberSelectLevel: !data.memberSelectLevel ? [''] : data.memberSelectLevel.split(','),
            content: data.content,
          };
          // 屏蔽黑名单
          if (data.blackmobileFilterType == 1) {
            this.detailFormData.filterCondition.push("2");
          }
          //同1买家
          if (data.remindOneTimesFlag) {
            this.detailFormData.filterCondition.push("1");
          }
          // 屏蔽中差评
          if (data.filterBadcommentCustomer == 1) {
            this.detailFormData.filterCondition.push("4");
          }
          // 屏蔽退过款客户
          if (data.filterRefundCustomer == 1) {
            this.detailFormData.filterCondition.push("5");
          }
          if (data.waybillFilterType == 3) {
            this.detailFormData.waybillFilterType = "1";
          }
          if (data.itemFilterType == 2) {
            this.detailFormData.isAllItem = "2";
          }
          if (data.itemFilterType == 1) {
            this.detailFormData.isAllItem = "0";
          }
          if (data.itemFilterType == 3) {
            this.detailFormData.isAllItem = "1";
          }
          // return
          const height = document.documentElement.clientHeight || document.body.clientHeight;
          if (this.topPX == "60px") {
            this.bodyHeight = height - 60;
          } else {
            this.bodyHeight = height - 60;
          }
          this.pageConditionCom = true;
        });
      }
    },
    /***
     * 删除任务
     * */
    deleteOrderCare(row) {
      // console.log(row);
      if (row.isOpen == 1) {
        this.$message.warning("开启状态的任务不可删除！");
        return;
      }
      this.$confirm("是否确认删除任务？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          // console.log(this.apiTypeActive);
          // return
          if (this.apiTypeActive == "refund") {
            delOrdersCareRefund(row.id).then((res) => {
              console.log(res);
              if(res.code == 1){
                this.$message.success("操作成功")
                this.getOrdersCareList()
              }else{
                if(res.data.message){
                  this.$message.error(res.data.message)
                }else{
                  this.$message.error(res.message)
                }
              }
            });
          } else if (this.apiTypeActive == "pop") {
            delOrdersCarePop(row.id).then((res) => {
              console.log(res);
              if(res.code == 1){
                this.$message.success("操作成功")
                this.getOrdersCareList()
              }else{
                if(res.data.message){
                  this.$message.error(res.data.message)
                }else{
                  this.$message.error(res.message)
                }
              }
            });
          } else {
            delOrdersCare(row.id).then((res) => {
              console.log(res);
              if(res.code == 1){
                this.$message.success("操作成功")
                this.getOrdersCareList()
              }else{
                if(res.data.message){
                  this.$message.error(res.data.message)
                }else{
                  this.$message.error(res.message)
                }
              }
            });
          }
        })
        .catch((action) => { });
    },
    //主页分页事件
    handleSizeChange(val) {
      this.paginationInfo.pageSize = val;
      this.paginationInfo.tableCurrentPage = 1;
      this.getOrdersCareList();
    },
    handleCurrentChange(val) {
      //console.log(val);
      this.paginationInfo.tableCurrentPage = val;
      this.getOrdersCareList();
    },
    /**
     * 任务查询条件重置
     */
    resetBtn() {
      // this.paginationInfo= {
      //   tableCurrentPage: 1,
      //   pageSize: 10,
      // },
      // console.log(11111111);
      this.paginationInfo.pageSize = 10;
      this.paginationInfo.tableCurrentPage = 1;
      this.search1.isOpen = "";
      this.search1.searchKeyWord = "";
      this.getOrdersCareList();
    },
    // 任务查询按钮
    seacherResult() {
      this.paginationInfo.tableCurrentPage = 1;
      this.getOrdersCareList();
    },
    //获取路径对应的下标
    getIndex(paths) {
      let orderType = 0;
      switch (paths) {
        case "/orderCare/orderCare/goodsOrderCare":
          orderType = 1;
          this.asideName = "下单关怀（货到）";
          this.paths = "/orderCare/orderCare/goodsOrderCare";
          break; //下单关怀（货到）
        case "/orderCare/orderCare/expediting":
          orderType = 2;
          this.asideName = "催付提醒";
          this.paths = "/orderCare/orderCare/expediting";
          break; //常规催付
        // case "/orderCare/orderCare/twiceExpediting":
        //   orderType = 3;
        //   this.asideName = "二次催付";
        //   this.paths = "/orderCare/orderCare/twiceExpediting";
        //   break; //二次催付
        case "/orderCare/orderCare/presaleExpediting":
          orderType = 4;
          this.asideName = "预售尾款催付";
          this.paths = "/orderCare/orderCare/presaleExpediting";
          break; //预售尾款催付
        case "/orderCare/payReminder/payReminder":
          orderType = 5;
          this.asideName = "付款关怀";
          this.paths = "/orderCare/payReminder/payReminder";
          break; //付款关怀
        case "/orderCare/transreMind/cancelMind":
          orderType = 6;
          this.asideName = "取消提醒";
          this.paths = "/orderCare/transreMind/cancelMind";
          break; //付款关怀
        case "/orderCare/transreMind/sendreMind":
          orderType = 7;
          this.asideName = "发货提醒";
          this.paths = "/orderCare/transreMind/sendreMind";
          break; //发货提醒
        case "/orderCare/transreMind/delayMind":
          orderType = 8;
          this.asideName = "迟发提醒";
          this.paths = "/orderCare/transreMind/delayMind";
          break; //迟发提醒
        case "/orderCare/transreMind/delivereMind":
          orderType = 9;
          this.asideName = "派件提醒";
          this.paths = "/orderCare/transreMind/delivereMind";
          break; //派件提醒
        case "/orderCare/transreMind/recvreMind":
          orderType = 10;
          this.asideName = "签收提醒";
          this.paths = "/orderCare/transreMind/recvreMind";
          break; //签收提醒
        case "/orderCare/transreMind/goodsBackMind":
          orderType = 11;
          this.asideName = "退货提醒";
          this.paths = "/orderCare/transreMind/goodsBackMind";
          break; //退货提醒
        case "/orderCare/moneyBack/moneyBack":
          orderType = 12;
          this.asideName = "完成提醒";
          this.paths = "/orderCare/moneyBack/moneyBack";
          break; //完成提醒
        case "/orderCare/comtCare/autoEvaluation":
          orderType = 13;
          this.asideName = "自动催评";
          this.paths = "/orderCare/comtCare/autoEvaluation";
          break; //自动催评
        case "/orderCare/comtCare/thankEvaluation":
          orderType = 14;
          this.asideName = "好评感谢";
          this.paths = "/orderCare/comtCare/thankEvaluation";
          break; //好评感谢
        case "/orderCare/comtCare/poorEvaluation":
          orderType = 15;
          this.asideName = "中差评安抚";
          this.paths = "/orderCare/comtCare/poorEvaluation";
          break; //中差评安抚
        case "/orderCare/comtCare/thankEvaluationOfficial":
          orderType = 20;
          this.asideName = "好评感谢（自营）";
          this.paths = "/orderCare/comtCare/thankEvaluationOfficial";
          break; //好评感谢
        case "/orderCare/comtCare/poorEvaluationOfficial":
          orderType = 21;
          this.asideName = "中差评安抚（自营）";
          this.paths = "/orderCare/comtCare/poorEvaluationOfficial";
          break; //中差评安抚
        case "/orderCare/refunCare/apply":
          orderType = 16;
          this.asideName = "申请退款";
          this.paths = "/orderCare/refunCare/apply";
          break; //申请退款
        case "/orderCare/refunCare/agree":
          orderType = 17;
          this.asideName = "同意退款";
          this.paths = "/orderCare/refunCare/agree";
          break; //同意退款
        case "/orderCare/refunCare/deny":
          orderType = 18;
          this.asideName = "拒绝退款";
          this.paths = "/orderCare/refunCare/deny";
          break; //拒绝退款
        case "/orderCare/refunCare/suces":
          orderType = 19;
          this.asideName = "退款成功";
          this.paths = "/orderCare/refunCare/suces";
          break; //退款成功
        case "/orderCare/memberCare/openCardRemind":
          orderType = 26;
          this.asideName = "入会关怀";
          this.paths = "/orderCare/memberCare/openCardRemind";
          break; //入会关怀
        case "/orderCare/memberCare/upgradeGift":
          orderType = 27;
          this.asideName = "升级有礼";
          this.paths = "/orderCare/memberCare/upgradeGift";
          break; //升级有礼
        case "/orderCare/memberCare/degradeRemind":
          orderType = 28;
          this.asideName = "降级关怀";
          this.paths = "/orderCare/memberCare/degradeRemind";
          break; //降级关怀
        case "/orderCare/memberCare/closeCardRemind":
          orderType = 29;
          this.asideName = "退会挽回";
          this.paths = "/orderCare/memberCare/closeCardRemind";
          break; //退会挽回
        case "/orderCare/memberCare/pointChangeRemind":
          orderType = 30;
          this.asideName = "积分变更通知";
          this.paths = "/orderCare/memberCare/pointChangeRemind";
          break; //积分变更通知
        case "/orderCare/shopCare/smartRecommendRemind":
          orderType = 31;
          this.asideName = "智能凑单提醒";
          this.paths = "/orderCare/shopCare/smartRecommendRemind";
          break; //智能凑单提醒
        case "/orderCare/shopCare/buyWithNoOpenCardRemind":
          orderType = 32;
          this.asideName = "购后入会提醒";
          this.paths = "/orderCare/shopCare/buyWithNoOpenCardRemind";
          break; //购后入会提醒
        case "/orderCare/shopCare/shopLivePreSaleOrderRemind":
          orderType = 33;
          this.asideName = "直播预售下单关怀";
          this.paths = "/orderCare/shopCare/shopLivePreSaleOrderRemind";
          break; //直播预售下单关怀
        case "/orderCare/shopCare/shopLiveOrderRemind":
          orderType = 34;
          this.asideName = "直播下单关怀";
          this.paths = "/orderCare/shopCare/shopLiveOrderRemind";
          break; //直播下单关怀
        default:
          orderType = 1;
      }
      return orderType;
    },
    // 对应提示语
    statusMessage(index) {
      return {
        1: "针对“货到付款”在下单时自动发送通知短信，提醒货到付款注意事项，有效减少货到付款订单拒收的情况",
        2: "针对已拍下“等待买家付款”的订单，自动提醒买家付款，提高订单付款率。",
        // 3: "首次催付过的订单如未付款，则自动进行二次催付，有效提高订单付款率。",
        4: "针对已拍下“等待买家付款”的预售订单，自动提醒买家付款，提高预售订单付款率。",
        5: "针对“已付款买家”发送付款提醒短信，避免买家上当受骗",
        6: "当买家取消订单后立即发送",
        7: "在宝贝发货时及时发送发货提醒短信到买家手机上，提醒买家宝贝已发货",
        8: "对已付款未发货的订单自动发送短信进行安抚买家",
        9: "在宝贝派件时及时发送派件提醒短信到买家手机上，提醒买家宝贝已派件(仅中通、京东快递)",
        10: "在宝贝签收时发送签收提醒短信到买家手机上，提醒买家宝贝已签收(仅中通、京东快递)",
        11: "针对“买家退货”的订单，向买家发送提醒",
        12: "针对“已交易完成”的订单，希望其下次再来购买",
        13: "对于订单完成但是未评价的买家，自动发送短信提醒买家好评",
        14: "针对“已给出好评”的订单，对买家进行好评感谢",
        15: "针对“给中差评评论”的订单，对买家进行安抚",
        16: "卖家申请退款时立即发送短信安抚买家",
        17: "卖家同意退款时立即发送短信通知买家",
        18: "卖家拒绝退款时立即发送短信通知买家",
        19: "卖家退款成功时，立即给买家发送短信",
        26: "会员入会后，自动对入会的会员进行消息触达",
        27: "会员升级后，自动对升级的会员进行消息触达",
        28: "会员降级后，自动对降级的会员进行消息触达",
        29: "会员退会后，自动对退会的会员进行消息触达",
        30: "可针对会员积分变更的情况，进行消息触达",
        31: "在买家下单后，根据条件发出凑单消息",
        32: "自动通知购买后未入会的客户，引导客户成为会员",
        33: "用户在直播间下预售单后发送消息提醒",
        34: "用户在直播间下单后发送消息提醒",
      }[index];
    },
    // 点击图标，路由跳转
    jumpToPage(_val) {
      this.selectIndex = 1;
      this.$router.push({ path: _val });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-box{
  display: flex;
  &-item{
    display: flex;
    align-items: center;
    margin-right: 50px;
    .data_title{
      margin-right: 8px;
    }
  }
}
.top {
  position: relative;
}

.top_content {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  min-width: 1057px;
  margin: 11px 20px 20px 20px;
}

.top-contain {
  // padding: 12px 20px 10px;
}

.line_icon {
  width: 4px;
  height: 14px;
  background: rgba(254, 77, 69, 1);
  opacity: 1;
  display: inline-block;
  margin-right: 6px;
  vertical-align: bottom;
  margin-bottom: 3px;
}

.tip_title {
  height: 22px;
  font-size: 16px;
  /* font-family: PingFang SC; */
  font-weight: 500;
  line-height: 22px;
  color: rgba(254, 77, 69, 1);
  opacity: 1;
  line-height: 22px;
}

.link_icon {
  width: 50px;
  height: 60px;
  vertical-align: middle;
}

.link_item {
  float: left;
  position: relative;
  cursor: pointer;
}

.link_item2 {
  // float: left;
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.isOpen {
  position: absolute;
  top: 0px;
  right: -23px;
  color: #fff;
  padding: 4px 6px;
  background: rgba(255, 151, 74, 1);
  box-shadow: 0px 2px 4px rgba(255, 151, 74, 0.5);
  opacity: 1;
  border-radius: 43px;
  padding: 2px 5px;
  font-size: 12px;
}

.link_title {
  font-size: 12px;
  // font-family:PingFang SC;
  font-weight: 500;
  line-height: 17px;
  color: #999;
  opacity: 1;
}

.select_text {
  color: #333;
}

.direction_line {
  color: #eeeeee;
  font-size: 24px;
  font-weight: bold;
}

.line1 {
  width: 200px;
  height: 3px;
  background: #eee;
  display: inline-block;
}

.line2 {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 3px;
  margin-left: -1px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 3px;
  margin-left: -1px;
}

.bottom1 {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 1px;
  margin-left: -12px;
}

.icon_content {
  position: relative;
  height: 360px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 23px;
  display: -webkit-box;
}

.order_care {
  position: relative;
  // width: 434px;
  height: 360px;
  // float: left;
}

.order_care_top {
  overflow: hidden;
}

.order_care_top_div {
  width: 278px;
}

.deal_care_div {
  width: 55px;
}

.order_care_bottom {
  width: 156px;
}

.margin {
  margin-left: 5px;
  margin-right: 5px;
  // position: absolute;
  // left: 50px;
  // top: 0px
}

.icon-item {
  float: left;
}

.icon-infont {
  width: 9px;
  border: 1px solid rgba(230, 230, 230, 1);
  // @include rotate(45deg);
  transform: rotate(45deg);
  float: right;
}

.icon-infont_left {
  width: 9px;
  border: 1px solid rgba(230, 230, 230, 1);
  // @include rotate(45deg);
  transform: rotate(-45deg);
  float: right;
}

.icon-infont_opp {
  width: 9px;
  border: 1px solid rgba(230, 230, 230, 1);
  // @include rotate(45deg);
  transform: rotate(-45deg);
  float: right;
  position: absolute;
  right: 0px;
  top: 8px;
}

.icon-infont2 {
  width: 48px;
  /*width: 500px;*/
  margin-top: 4px;
  border: 1px solid rgba(230, 230, 230, 1);
}

.icon-infont3 {
  margin-top: 10px;
  height: 60px;
  width: 0;
  /*float: left;*/
  border: 1px solid rgba(230, 230, 230, 1);
  margin-bottom: -4px;
}

.icon-infont4 {
  width: 9px;
  border: 1px solid rgba(230, 230, 230, 1);
  // @include rotate(135deg);
  transform: rotate(135deg);
  float: right;
}

.icon-infont4_opp {
  width: 9px;
  border: 1px solid rgba(230, 230, 230, 1);
  // @include rotate(135deg);
  transform: rotate(-135deg);
  position: absolute;
  left: -6px;
}

.icon-infont5 {
  margin-top: 10px;
  height: 96px;
  width: 16px;
  border-left: 2px solid rgba(230, 230, 230, 1);
  border-bottom: 2px solid rgba(230, 230, 230, 1);
}

.icon-infont6 {
  width: 219px;
  /*width: 500px;*/
  margin-top: 4px;
  border: 1px solid rgba(230, 230, 230, 1);
}

.icon-small-item {
  width: 49px;
  height: 49px;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  line-height: 49px;
  cursor: pointer;

  /*border: 1px dashed #999;*/
  span {
    font-size: 26px;
  }
}

.icon-title {
  position: absolute;
  width: 103px;
  font-size: 13px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 20px;
  color: rgba(153, 153, 153, 1);
  text-align: center;
  margin-left: -26px;
}

.deal_care {
  position: relative;
  height: 260px;
  // float: left;
}

.after_care {
  position: relative;
  height: 360px;

  // float: right;
  .after_care_div {
    width: 224px;
  }
}

.br {
  width: 1px;
  height: 360px;
  margin: 0 24px;
  // float: left;
  background: rgba(240, 240, 240, 1);
}

.modules_title {
  font-size: 14px;
  height: 20px;
  color: #333;
  font-weight: bold;
  line-height: 20px;
}

.icon_content2 {
  height: 240px;
  width: 1050px;
  display: inline-block;
  position: relative;
}

.main_content {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 20px;

  .tab_all {
    border-bottom: 1px solid #f6f6f6;
    margin-bottom: 20px;
  }

  .tab_item {
    font-size: 14px;
    // font-family:PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: rgba(153, 153, 153, 1);
    opacity: 1;
    margin-right: 22px;
    padding: 15px 0px;
    display: inline-block;
    cursor: pointer;
  }

  .active {
    border-bottom: 2px solid #fe4d45;
    color: #fe4d45;
  }

  .create_btn3 {
    width: 98px;
    height: 32px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    display: inline-block;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-left: 28px;
    cursor: pointer;
  }

  .right_allBtn {
    float: right;
    margin-right: 28px;
    color: #333;
    font-size: 14px;
  }
}

.status_btn {
  width: 98px;
  // height: 32px;
  background-color: #fff;
  font-size: 14px;
}

.status_btn1 {
  color: #fe4d45;
  border-color: #fe4d45;
  margin-left: -8px;
}

.status_btn1:hover {
  color: #ffffff;
  background-color: #fe4d45;
}

.status_btn2 {
  margin-left: 8px;
  color: #333;
  border-color: #d9d9d9;
}

.status_btn2:hover {
  color: #fe4d45;
  border-color: #fe4d45;
  background-color: #ffe5e5;
}

.status_btn3 {
  margin-left: 8px;
  vertical-align: middle;
  width: 98px;
  height: 32px;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background-color: #fff;

  &:hover {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }

  &:active {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }
}

.status_btn4 {
  margin-left: 12px;
  vertical-align: middle;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;

  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.edit_btn {
  color: #7f85e9;
  width: auto;

  &:hover {
    color: #fe4d45;
  }
}

.cloce_btn {
  color: #7f85e9;
  width: auto;

  &:hover {
    color: #fe4d45;
  }
}

.del_btn {
  font-size: 14px;
  padding: 0px !important;
  border: 0px;
  height: 20px;
  line-height: 20px;
  color: #fe4d45;
  margin-left: 0px;
}

.question_icon {
  width: 14px;
  height: 14px;
  color: #ccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px;
  font-weight: normal;
}

.question_icon:hover {
  color: #fe4d45;
  border: 1px solid #fe4d45;
}

.search_item {
  display: inline-block;
  margin-right: 79px;
  margin-bottom: 16px;
  color: #333;

  @media only screen and (max-width: 1590px) {
    margin-right: 25px;
  }

  @media only screen and (max-width: 1360px) {
    margin-right: 15px;
  }

  .title {
    display: inline-block;
    width: 70px;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    margin: 0px;
  }
}

.search_item1 {
  display: inline-block;
  margin-right: 79px;
  margin-bottom: 16px;
  color: #333;

  @media only screen and (max-width: 1590px) {
    margin-right: 25px;
  }

  @media only screen and (max-width: 1360px) {
    margin-right: 15px;
  }

  .title {
    display: inline-block;
    width: 70px;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    margin: 0px;
  }
}

.tab_item_box {
  padding: 0px 28px 30px;
}

.table-box {
  margin-top: 20px;
}

.data_title {
  height: 22px;
  font-size: 16px;
  /* font-family: PingFang SC; */
  font-weight: 500;
  line-height: 22px;
  color: rgba(254, 77, 69, 1);
  margin-bottom: 20px;

  .line {
    width: 4px;
    height: 14px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    display: inline-block;
    margin-right: 6px;
    vertical-align: middle;
  }
}

.today_item {
  display: inline-block;
  // padding-left: 40px;
  border-left: 1px solid #f0f0f0;
  width: 20%;
  position: relative;
  margin-bottom: 32px;
}

.today_item:first-child {
  border-left: 0px;
}

.data_name {
  height: 20px;
  font-size: 14px;
  /* font-family: PingFang SC; */
  font-weight: 400;
  line-height: 20px;
  color: rgba(153, 153, 153, 1);
  opacity: 1;
  display: inline-block;
  margin: 3px 0 8px;
}

.data_num {
  height: 29px;
  font-size: 24px;
  // font-family: SF Pro Display;
  font-weight: 400;
  line-height: 29px;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 4px;
}

.data_num_unit {
  margin-left: 4px;
  height: 20px;
  font-size: 14px;
  /* font-family: PingFang SC; */
  font-weight: 400;
  line-height: 20px;
  display: inline-block;
}

.edit_price {
  width: 56px;
  height: 20px;
  font-size: 14px;
  // font-family:PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: rgba(254, 77, 69, 1);
  opacity: 1;
  position: absolute;
  top: 3px;
  left: 89px;
  cursor: pointer;
}

.marginRight_50 {
  margin-right: 50px;
}

.float_right_button {
  float: right;

  .export_btn {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    opacity: 1;
    border-radius: 4px;
    margin-right: 2px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
}

.special-two {
  height: 50px;
  line-height: 50px;
  padding: 0;
}

.my_chart {
  margin: 20px 20px 36px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  padding-top: 28px;
}

.width25 {
  width: 25%;
}

// .icon-infont2.second,
// .icon-item.second {
//   width: 180px  !important;
// }
@media screen and (max-width: 1950px) and (min-width: 1801px) {

  .icon-infont2.second2,
  .icon-item.second2 {
    width: 100px !important;
  }
}

// @media screen and (max-width:1800px) and (min-width: 1701px) {
//   .icon-infont2.second,
//   .icon-item.second {
//     width: 120px !important;
//   }
// }
@media screen and (max-width: 1700px) and (min-width: 1601px) {

  .icon-infont2.second,
  .icon-item.second {
    width: 50px !important;
  }

  .order_care_top_div {
    width: 270px;
  }

  .order_care_bottom {
    width: 156px;
  }

  .br {
    margin: 0 24px;
  }
}

@media screen and (max-width: 1500px) and (min-width: 1401px) {

  .icon-infont2.second,
  .icon-item.second {
    width: 31px !important;
  }

  .order_care_top_div {
    width: 220px;
  }

  .icon-infont6.second3 {
    width: 88px !important;
  }

  .order_care_bottom {
    width: 116px;
  }

  .br {
    margin: 0 16px;
  }
}

@media screen and (max-width: 1400px) and (min-width: 1301px) {

  .icon-infont2.second,
  .icon-item.second {
    width: 26px !important;
  }

  .order_care_top_div {
    width: 220px;
  }

  .icon-infont6.second3 {
    width: 26px !important;
  }

  .order_care_bottom {
    width: 116px;
  }

  .br {
    margin: 0 16px;
  }

  .icon-infont6 {
    width: 166px !important;
  }

  .after_care_div {
    width: 180px !important;
  }
}

@media screen and (max-width: 1300px) {

  .icon-infont2.second,
  .icon-item.second {
    width: 20px !important;
  }

  .icon-infont6.second3 {
    width: 26px !important;
  }

  .order_care_top_div {
    width: 210px;
  }

  .order_care_bottom {
    width: 110px;
  }

  .br {
    margin: 0 12px;
  }

  .deal_care_div {
    width: 40px;
  }

  .after_care_div {
    width: 140px;
  }
}

// @media screen and (max-width:1500px) and (min-width: 1401px) {
//   .icon-infont2.second,
//   .icon-item.second {
//     width: 36px !important;
//   }
//   .order_care_top_div{
//     width: 240px;
//   }
//   .order_care_bottom{
//     width: 136px;
//   }
//   .br{
//     margin:0 16px
//   }
// }
</style>
<style lang="scss">
.el-scrollbar {
  height: 100%;
}

// .el-scrollbar__wrap {
//   overflow: scroll;
//   width: 110%;
//   height: 120%;
// }
.page_order_care {
  // 计步器
  // .aaa6{
  //   .el-input-number--small .el-input-number__increase,
  //   .el-input-number--small .el-input-number__decrease {
  //       width: 22px!important;
  //       font-size: 14px!important;
  //       height: 24px;
  //   }
  //   .el-input__inner{
  //     line-height: 24px;
  //     height: 24px!important;
  //   }
  // }

  .table-bottom {
    height: 40px;

    .el-table__body-wrapper {
      display: none !important;
    }
  }

  .el-dialog .el-dialog__body {
    padding: 20px 30px;
  }
}
</style>
